// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/cursor-editorInk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/cursor-editorTextHighlight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/cursor-editorFreeHighlight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/cursor-editorFreeText.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("images/editor-toolbar-delete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("images/toolbarButton-editorHighlight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("images/altText_add.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("images/altText_done.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("images/toolbarButton-menuArrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("images/loading-icon.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.dialog{
  --dialog-bg-color:white;
  --dialog-border-color:white;
  --dialog-shadow:0 2px 14px 0 rgb(58 57 68 / 0.2);
  --text-primary-color:#15141a;
  --text-secondary-color:#5b5b66;
  --hover-filter:brightness(0.9);
  --focus-ring-color:#0060df;
  --focus-ring-outline:2px solid var(--focus-ring-color);

  --textarea-border-color:#8f8f9d;
  --textarea-bg-color:white;
  --textarea-fg-color:var(--text-secondary-color);

  --radio-bg-color:#f0f0f4;
  --radio-checked-bg-color:#fbfbfe;
  --radio-border-color:#8f8f9d;
  --radio-checked-border-color:#0060df;

  --button-secondary-bg-color:#f0f0f4;
  --button-secondary-fg-color:var(--text-primary-color);
  --button-secondary-border-color:var(--button-secondary-bg-color);
  --button-secondary-hover-bg-color:var(--button-secondary-bg-color);
  --button-secondary-hover-fg-color:var(--button-secondary-fg-color);
  --button-secondary-hover-border-color:var(--button-secondary-hover-bg-color);

  --button-primary-bg-color:#0060df;
  --button-primary-fg-color:#fbfbfe;
  --button-primary-hover-bg-color:var(--button-primary-bg-color);
  --button-primary-hover-fg-color:var(--button-primary-fg-color);
  --button-primary-hover-border-color:var(--button-primary-hover-bg-color);

  font:message-box;
  font-size:13px;
  font-weight:400;
  line-height:150%;
  border-radius:4px;
  padding:12px 16px;
  border:1px solid var(--dialog-border-color);
  background:var(--dialog-bg-color);
  color:var(--text-primary-color);
  box-shadow:var(--dialog-shadow);
}

@media (prefers-color-scheme: dark){

.dialog{
    --dialog-bg-color:#1c1b22;
    --dialog-border-color:#1c1b22;
    --dialog-shadow:0 2px 14px 0 #15141a;
    --text-primary-color:#fbfbfe;
    --text-secondary-color:#cfcfd8;
    --focus-ring-color:#0df;
    --hover-filter:brightness(1.4);

    --textarea-bg-color:#42414d;

    --radio-bg-color:#2b2a33;
    --radio-checked-bg-color:#15141a;
    --radio-checked-border-color:#0df;

    --button-secondary-bg-color:#2b2a33;
    --button-primary-bg-color:#0df;
    --button-primary-fg-color:#15141a;
}
  }

@media screen and (forced-colors: active){

.dialog{
    --dialog-bg-color:Canvas;
    --dialog-border-color:CanvasText;
    --dialog-shadow:none;
    --text-primary-color:CanvasText;
    --text-secondary-color:CanvasText;
    --hover-filter:none;
    --focus-ring-color:ButtonBorder;

    --textarea-border-color:ButtonBorder;
    --textarea-bg-color:Field;
    --textarea-fg-color:ButtonText;

    --radio-bg-color:ButtonFace;
    --radio-checked-bg-color:ButtonFace;
    --radio-border-color:ButtonText;
    --radio-checked-border-color:ButtonText;

    --button-secondary-bg-color:ButtonFace;
    --button-secondary-fg-color:ButtonText;
    --button-secondary-border-color:ButtonText;
    --button-secondary-hover-bg-color:AccentColor;
    --button-secondary-hover-fg-color:AccentColorText;

    --button-primary-bg-color:ButtonText;
    --button-primary-fg-color:ButtonFace;
    --button-primary-hover-bg-color:AccentColor;
    --button-primary-hover-fg-color:AccentColorText;
}
  }

.dialog .mainContainer *:focus-visible{
      outline:var(--focus-ring-outline);
      outline-offset:2px;
    }

.dialog .mainContainer .radio{
      display:flex;
      flex-direction:column;
      align-items:flex-start;
      gap:4px;
    }

.dialog .mainContainer .radio > .radioButton{
        display:flex;
        gap:8px;
        align-self:stretch;
        align-items:center;
      }

.dialog .mainContainer .radio > .radioButton input{
          -webkit-appearance:none;
                  appearance:none;
          box-sizing:border-box;
          width:16px;
          height:16px;
          border-radius:50%;
          background-color:var(--radio-bg-color);
          border:1px solid var(--radio-border-color);
        }

.dialog .mainContainer .radio > .radioButton input:hover{
            filter:var(--hover-filter);
          }

.dialog .mainContainer .radio > .radioButton input:checked{
            background-color:var(--radio-checked-bg-color);
            border:4px solid var(--radio-checked-border-color);
          }

.dialog .mainContainer .radio > .radioLabel{
        display:flex;
        padding-inline-start:24px;
        align-items:flex-start;
        gap:10px;
        align-self:stretch;
      }

.dialog .mainContainer .radio > .radioLabel > span{
          flex:1 0;
          font-size:11px;
          color:var(--text-secondary-color);
        }

.dialog .mainContainer button{
      border-radius:4px;
      border:1px solid;
      font:menu;
      font-weight:600;
      padding:4px 16px;
      width:auto;
      height:32px;
    }

.dialog .mainContainer button:hover{
        cursor:pointer;
        filter:var(--hover-filter);
      }

.dialog .mainContainer button.secondaryButton{
        color:var(--button-secondary-fg-color);
        background-color:var(--button-secondary-bg-color);
        border-color:var(--button-secondary-border-color);
      }

.dialog .mainContainer button.secondaryButton:hover{
          color:var(--button-secondary-hover-fg-color);
          background-color:var(--button-secondary-hover-bg-color);
          border-color:var(--button-secondary-hover-border-color);
        }

.dialog .mainContainer button.primaryButton{
        color:var(--button-primary-hover-fg-color);
        background-color:var(--button-primary-hover-bg-color);
        border-color:var(--button-primary-hover-border-color);
        opacity:1;
      }

.dialog .mainContainer button.primaryButton:hover{
          color:var(--button-primary-hover-fg-color);
          background-color:var(--button-primary-hover-bg-color);
          border-color:var(--button-primary-hover-border-color);
        }

.dialog .mainContainer textarea{
      font:inherit;
      padding:8px;
      resize:none;
      margin:0;
      box-sizing:border-box;
      border-radius:4px;
      border:1px solid var(--textarea-border-color);
      background:var(--textarea-bg-color);
      color:var(--textarea-fg-color);
    }

.dialog .mainContainer textarea:focus{
        outline-offset:0;
        border-color:transparent;
      }

.dialog .mainContainer textarea:disabled{
        pointer-events:none;
        opacity:0.4;
      }

.textLayer{
  position:absolute;
  text-align:left;
  text-align:initial;
  inset:0;
  overflow:clip;
  opacity:1;
  line-height:1;
  -webkit-text-size-adjust:none;
     -moz-text-size-adjust:none;
          text-size-adjust:none;
  forced-color-adjust:none;
  transform-origin:0 0;
  caret-color:CanvasText;
  z-index:0;
}

.textLayer.highlighting{
    touch-action:none;
  }

.textLayer :is(span, br){
    color:transparent;
    position:absolute;
    white-space:pre;
    cursor:text;
    transform-origin:0% 0%;
  }

.textLayer > :not(.markedContent),
  .textLayer .markedContent span:not(.markedContent){
    z-index:1;
  }

.textLayer span.markedContent{
    top:0;
    height:0;
  }

.textLayer .highlight{
    --highlight-bg-color:rgb(180 0 170 / 0.25);
    --highlight-selected-bg-color:rgb(0 100 0 / 0.25);
    --highlight-backdrop-filter:none;
    --highlight-selected-backdrop-filter:none;

    margin:-1px;
    padding:1px;
    background-color:var(--highlight-bg-color);
    -webkit-backdrop-filter:var(--highlight-backdrop-filter);
            backdrop-filter:var(--highlight-backdrop-filter);
    border-radius:4px;
  }

@media screen and (forced-colors: active){

.textLayer .highlight{
      --highlight-bg-color:transparent;
      --highlight-selected-bg-color:transparent;
      --highlight-backdrop-filter:var(--hcm-highlight-filter);
      --highlight-selected-backdrop-filter:var(
        --hcm-highlight-selected-filter
      );
  }
    }

.textLayer .highlight.appended{
      position:static;
      position:initial;
    }

.textLayer .highlight.begin{
      border-radius:4px 0 0 4px;
    }

.textLayer .highlight.end{
      border-radius:0 4px 4px 0;
    }

.textLayer .highlight.middle{
      border-radius:0;
    }

.textLayer .highlight.selected{
      background-color:var(--highlight-selected-bg-color);
      -webkit-backdrop-filter:var(--highlight-selected-backdrop-filter);
              backdrop-filter:var(--highlight-selected-backdrop-filter);
    }

.textLayer ::selection{
    background:rgba(0 0 255 / 0.25);
    background:color-mix(in srgb, AccentColor, transparent 75%);
  }

.textLayer br::selection{
    background:transparent;
  }

.textLayer .endOfContent{
    display:block;
    position:absolute;
    inset:100% 0 0;
    z-index:0;
    cursor:default;
    -webkit-user-select:none;
            user-select:none;
  }

.textLayer .endOfContent.active{
      top:0;
    }

.annotationLayer{
  --annotation-unfocused-field-background:url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
  --input-focus-border-color:Highlight;
  --input-focus-outline:1px solid Canvas;
  --input-unfocused-border-color:transparent;
  --input-disabled-border-color:transparent;
  --input-hover-border-color:black;
  --link-outline:none;

  position:absolute;
  top:0;
  left:0;
  pointer-events:none;
  transform-origin:0 0;
}

@media screen and (forced-colors: active){

.annotationLayer{
    --input-focus-border-color:CanvasText;
    --input-unfocused-border-color:ActiveText;
    --input-disabled-border-color:GrayText;
    --input-hover-border-color:Highlight;
    --link-outline:1.5px solid LinkText;
}

    .annotationLayer .textWidgetAnnotation :is(input, textarea):required, .annotationLayer .choiceWidgetAnnotation select:required, .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input:required{
      outline:1.5px solid selectedItem;
    }

    .annotationLayer .linkAnnotation{
      outline:var(--link-outline);
    }

      .annotationLayer .linkAnnotation:hover{
        -webkit-backdrop-filter:var(--hcm-highlight-filter);
                backdrop-filter:var(--hcm-highlight-filter);
      }

      .annotationLayer .linkAnnotation > a:hover{
        opacity:0 !important;
        background:none !important;
        box-shadow:none;
      }

    .annotationLayer .popupAnnotation .popup{
      outline:calc(1.5px * var(--scale-factor)) solid CanvasText !important;
      background-color:ButtonFace !important;
      color:ButtonText !important;
    }

    .annotationLayer .highlightArea:hover::after{
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      -webkit-backdrop-filter:var(--hcm-highlight-filter);
              backdrop-filter:var(--hcm-highlight-filter);
      content:"";
      pointer-events:none;
    }

    .annotationLayer .popupAnnotation.focused .popup{
      outline:calc(3px * var(--scale-factor)) solid Highlight !important;
    }
  }

.annotationLayer[data-main-rotation="90"] .norotate{
    transform:rotate(270deg) translateX(-100%);
  }

.annotationLayer[data-main-rotation="180"] .norotate{
    transform:rotate(180deg) translate(-100%, -100%);
  }

.annotationLayer[data-main-rotation="270"] .norotate{
    transform:rotate(90deg) translateY(-100%);
  }

.annotationLayer.disabled section,
    .annotationLayer.disabled .popup{
      pointer-events:none;
    }

.annotationLayer .annotationContent{
    position:absolute;
    width:100%;
    height:100%;
    pointer-events:none;
  }

.annotationLayer .annotationContent.freetext{
      background:transparent;
      border:none;
      inset:0;
      overflow:visible;
      white-space:nowrap;
      font:10px sans-serif;
      line-height:1.35;
      -webkit-user-select:none;
              user-select:none;
    }

.annotationLayer section{
    position:absolute;
    text-align:left;
    text-align:initial;
    pointer-events:auto;
    box-sizing:border-box;
    transform-origin:0 0;
  }

.annotationLayer section:has(div.annotationContent) canvas.annotationContent{
        display:none;
      }

.annotationLayer :is(.linkAnnotation, .buttonWidgetAnnotation.pushButton) > a{
    position:absolute;
    font-size:1em;
    top:0;
    left:0;
    width:100%;
    height:100%;
  }

.annotationLayer :is(.linkAnnotation, .buttonWidgetAnnotation.pushButton):not(.hasBorder)
    > a:hover{
    opacity:0.2;
    background-color:rgb(255 255 0);
    box-shadow:0 2px 10px rgb(255 255 0);
  }

.annotationLayer .linkAnnotation.hasBorder:hover{
    background-color:rgb(255 255 0 / 0.2);
  }

.annotationLayer .hasBorder{
    background-size:100% 100%;
  }

.annotationLayer .textAnnotation img{
    position:absolute;
    cursor:pointer;
    width:100%;
    height:100%;
    top:0;
    left:0;
  }

.annotationLayer .textWidgetAnnotation :is(input, textarea), .annotationLayer .choiceWidgetAnnotation select, .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input{
    background-image:var(--annotation-unfocused-field-background);
    border:2px solid var(--input-unfocused-border-color);
    box-sizing:border-box;
    font:calc(9px * var(--scale-factor)) sans-serif;
    height:100%;
    margin:0;
    vertical-align:top;
    width:100%;
  }

.annotationLayer .textWidgetAnnotation :is(input, textarea):required, .annotationLayer .choiceWidgetAnnotation select:required, .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input:required{
    outline:1.5px solid red;
  }

.annotationLayer .choiceWidgetAnnotation select option{
    padding:0;
  }

.annotationLayer .buttonWidgetAnnotation.radioButton input{
    border-radius:50%;
  }

.annotationLayer .textWidgetAnnotation textarea{
    resize:none;
  }

.annotationLayer .textWidgetAnnotation [disabled]:is(input, textarea), .annotationLayer .choiceWidgetAnnotation select[disabled], .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input[disabled]{
    background:none;
    border:2px solid var(--input-disabled-border-color);
    cursor:not-allowed;
  }

.annotationLayer .textWidgetAnnotation :is(input, textarea):hover, .annotationLayer .choiceWidgetAnnotation select:hover, .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input:hover{
    border:2px solid var(--input-hover-border-color);
  }

.annotationLayer .textWidgetAnnotation :is(input, textarea):hover, .annotationLayer .choiceWidgetAnnotation select:hover, .annotationLayer .buttonWidgetAnnotation.checkBox input:hover{
    border-radius:2px;
  }

.annotationLayer .textWidgetAnnotation :is(input, textarea):focus, .annotationLayer .choiceWidgetAnnotation select:focus{
    background:none;
    border:2px solid var(--input-focus-border-color);
    border-radius:2px;
    outline:var(--input-focus-outline);
  }

.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) :focus{
    background-image:none;
    background-color:transparent;
  }

.annotationLayer .buttonWidgetAnnotation.checkBox :focus{
    border:2px solid var(--input-focus-border-color);
    border-radius:2px;
    outline:var(--input-focus-outline);
  }

.annotationLayer .buttonWidgetAnnotation.radioButton :focus{
    border:2px solid var(--input-focus-border-color);
    outline:var(--input-focus-outline);
  }

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,
  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after,
  .annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before{
    background-color:CanvasText;
    content:"";
    display:block;
    position:absolute;
  }

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,
  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after{
    height:80%;
    left:45%;
    width:1px;
  }

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before{
    transform:rotate(45deg);
  }

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after{
    transform:rotate(-45deg);
  }

.annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before{
    border-radius:50%;
    height:50%;
    left:25%;
    top:25%;
    width:50%;
  }

.annotationLayer .textWidgetAnnotation input.comb{
    font-family:monospace;
    padding-left:2px;
    padding-right:0;
  }

.annotationLayer .textWidgetAnnotation input.comb:focus{
    width:103%;
  }

.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input{
    -webkit-appearance:none;
            appearance:none;
  }

.annotationLayer .fileAttachmentAnnotation .popupTriggerArea{
    height:100%;
    width:100%;
  }

.annotationLayer .popupAnnotation{
    position:absolute;
    font-size:calc(9px * var(--scale-factor));
    pointer-events:none;
    width:-webkit-max-content;
    width:max-content;
    max-width:45%;
    height:auto;
  }

.annotationLayer .popup{
    background-color:rgb(255 255 153);
    box-shadow:0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor)) rgb(136 136 136);
    border-radius:calc(2px * var(--scale-factor));
    outline:1.5px solid rgb(255 255 74);
    padding:calc(6px * var(--scale-factor));
    cursor:pointer;
    font:message-box;
    white-space:normal;
    word-wrap:break-word;
    pointer-events:auto;
  }

.annotationLayer .popupAnnotation.focused .popup{
    outline-width:3px;
  }

.annotationLayer .popup *{
    font-size:calc(9px * var(--scale-factor));
  }

.annotationLayer .popup > .header{
    display:inline-block;
  }

.annotationLayer .popup > .header h1{
    display:inline;
  }

.annotationLayer .popup > .header .popupDate{
    display:inline-block;
    margin-left:calc(5px * var(--scale-factor));
    width:-moz-fit-content;
    width:-webkit-fit-content;
    width:fit-content;
  }

.annotationLayer .popupContent{
    border-top:1px solid rgb(51 51 51);
    margin-top:calc(2px * var(--scale-factor));
    padding-top:calc(2px * var(--scale-factor));
  }

.annotationLayer .richText > *{
    white-space:pre-wrap;
    font-size:calc(9px * var(--scale-factor));
  }

.annotationLayer .popupTriggerArea{
    cursor:pointer;
  }

.annotationLayer section svg{
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
  }

.annotationLayer .annotationTextContent{
    position:absolute;
    width:100%;
    height:100%;
    opacity:0;
    color:transparent;
    -webkit-user-select:none;
            user-select:none;
    pointer-events:none;
  }

.annotationLayer .annotationTextContent span{
      width:100%;
      display:inline-block;
    }

.annotationLayer svg.quadrilateralsContainer{
    contain:strict;
    width:0;
    height:0;
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
  }

:root{
  --xfa-unfocused-field-background:url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
  --xfa-focus-outline:auto;
}

@media screen and (forced-colors: active){
  :root{
    --xfa-focus-outline:2px solid CanvasText;
  }
  .xfaLayer *:required{
    outline:1.5px solid selectedItem;
  }
}

.xfaLayer{
  background-color:transparent;
}

.xfaLayer .highlight{
  margin:-1px;
  padding:1px;
  background-color:rgb(239 203 237);
  border-radius:4px;
}

.xfaLayer .highlight.appended{
  position:static;
  position:initial;
}

.xfaLayer .highlight.begin{
  border-radius:4px 0 0 4px;
}

.xfaLayer .highlight.end{
  border-radius:0 4px 4px 0;
}

.xfaLayer .highlight.middle{
  border-radius:0;
}

.xfaLayer .highlight.selected{
  background-color:rgb(203 223 203);
}

.xfaPage{
  overflow:hidden;
  position:relative;
}

.xfaContentarea{
  position:absolute;
}

.xfaPrintOnly{
  display:none;
}

.xfaLayer{
  position:absolute;
  text-align:left;
  text-align:initial;
  top:0;
  left:0;
  transform-origin:0 0;
  line-height:1.2;
}

.xfaLayer *{
  color:inherit;
  font:inherit;
  font-style:inherit;
  font-weight:inherit;
  font-feature-settings:inherit;
  font-kerning:inherit;
  letter-spacing:-0.01px;
  text-align:inherit;
  text-decoration:inherit;
  box-sizing:border-box;
  background-color:transparent;
  padding:0;
  margin:0;
  pointer-events:auto;
  line-height:inherit;
}

.xfaLayer *:required{
  outline:1.5px solid red;
}

.xfaLayer div,
.xfaLayer svg,
.xfaLayer svg *{
  pointer-events:none;
}

.xfaLayer a{
  color:blue;
}

.xfaRich li{
  margin-left:3em;
}

.xfaFont{
  color:black;
  font-weight:normal;
  font-feature-settings:"kern" off;
  font-kerning:none;
  font-size:10px;
  font-style:normal;
  letter-spacing:0;
  text-decoration:none;
  vertical-align:0;
}

.xfaCaption{
  overflow:hidden;
  flex:0 0 auto;
}

.xfaCaptionForCheckButton{
  overflow:hidden;
  flex:1 1 auto;
}

.xfaLabel{
  height:100%;
  width:100%;
}

.xfaLeft{
  display:flex;
  flex-direction:row;
  align-items:center;
}

.xfaRight{
  display:flex;
  flex-direction:row-reverse;
  align-items:center;
}

:is(.xfaLeft, .xfaRight) > :is(.xfaCaption, .xfaCaptionForCheckButton){
  max-height:100%;
}

.xfaTop{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
}

.xfaBottom{
  display:flex;
  flex-direction:column-reverse;
  align-items:flex-start;
}

:is(.xfaTop, .xfaBottom) > :is(.xfaCaption, .xfaCaptionForCheckButton){
  width:100%;
}

.xfaBorder{
  background-color:transparent;
  position:absolute;
  pointer-events:none;
}

.xfaWrapped{
  width:100%;
  height:100%;
}

:is(.xfaTextfield, .xfaSelect):focus{
  background-image:none;
  background-color:transparent;
  outline:auto;
  outline:var(--xfa-focus-outline);
  outline-offset:-1px;
}

:is(.xfaCheckbox, .xfaRadio):focus{
  outline:auto;
  outline:var(--xfa-focus-outline);
}

.xfaTextfield,
.xfaSelect{
  height:100%;
  width:100%;
  flex:1 1 auto;
  border:none;
  resize:none;
  background-image:url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
  background-image:var(--xfa-unfocused-field-background);
}

.xfaSelect{
  padding-inline:2px;
}

:is(.xfaTop, .xfaBottom) > :is(.xfaTextfield, .xfaSelect){
  flex:0 1 auto;
}

.xfaButton{
  cursor:pointer;
  width:100%;
  height:100%;
  border:none;
  text-align:center;
}

.xfaLink{
  width:100%;
  height:100%;
  position:absolute;
  top:0;
  left:0;
}

.xfaCheckbox,
.xfaRadio{
  width:100%;
  height:100%;
  flex:0 0 auto;
  border:none;
}

.xfaRich{
  white-space:pre-wrap;
  width:100%;
  height:100%;
}

.xfaImage{
  object-position:left top;
  object-fit:contain;
  width:100%;
  height:100%;
}

.xfaLrTb,
.xfaRlTb,
.xfaTb{
  display:flex;
  flex-direction:column;
  align-items:stretch;
}

.xfaLr{
  display:flex;
  flex-direction:row;
  align-items:stretch;
}

.xfaRl{
  display:flex;
  flex-direction:row-reverse;
  align-items:stretch;
}

.xfaTb > div{
  justify-content:left;
}

.xfaPosition{
  position:relative;
}

.xfaArea{
  position:relative;
}

.xfaValignMiddle{
  display:flex;
  align-items:center;
}

.xfaTable{
  display:flex;
  flex-direction:column;
  align-items:stretch;
}

.xfaTable .xfaRow{
  display:flex;
  flex-direction:row;
  align-items:stretch;
}

.xfaTable .xfaRlRow{
  display:flex;
  flex-direction:row-reverse;
  align-items:stretch;
  flex:1 1;
}

.xfaTable .xfaRlRow > div{
  flex:1 1;
}

:is(.xfaNonInteractive, .xfaDisabled, .xfaReadOnly) :is(input, textarea){
  background:transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background:initial;
}

@media print{
  .xfaTextfield,
  .xfaSelect{
    background:transparent;
  }

  .xfaSelect{
    -webkit-appearance:none;
            appearance:none;
    text-indent:1px;
    text-overflow:"";
  }
}

.canvasWrapper svg{
    transform:none;
  }

.canvasWrapper svg[data-main-rotation="90"] mask,
      .canvasWrapper svg[data-main-rotation="90"] use:not(.clip, .mask){
        transform:matrix(0, 1, -1, 0, 1, 0);
      }

.canvasWrapper svg[data-main-rotation="180"] mask,
      .canvasWrapper svg[data-main-rotation="180"] use:not(.clip, .mask){
        transform:matrix(-1, 0, 0, -1, 1, 1);
      }

.canvasWrapper svg[data-main-rotation="270"] mask,
      .canvasWrapper svg[data-main-rotation="270"] use:not(.clip, .mask){
        transform:matrix(0, -1, 1, 0, 0, 1);
      }

.canvasWrapper svg.highlight{
      --blend-mode:multiply;

      position:absolute;
      mix-blend-mode:var(--blend-mode);
    }

@media screen and (forced-colors: active){

.canvasWrapper svg.highlight{
        --blend-mode:difference;
    }
      }

.canvasWrapper svg.highlight:not(.free){
        fill-rule:evenodd;
      }

.canvasWrapper svg.highlightOutline{
      position:absolute;
      mix-blend-mode:normal;
      fill-rule:evenodd;
      fill:none;
    }

.canvasWrapper svg.highlightOutline.hovered:not(.free):not(.selected){
          stroke:#8f8f9d;
          stroke:var(--hover-outline-color);
          stroke-width:2px;
          stroke-width:var(--outline-width);
        }

.canvasWrapper svg.highlightOutline.selected:not(.free) .mainOutline{
            stroke:#f0f0f4;
            stroke:var(--outline-around-color);
            stroke-width:calc(
              2px + 2 * 1px
            );
            stroke-width:calc(
              var(--outline-width) + 2 * var(--outline-around-width)
            );
          }

.canvasWrapper svg.highlightOutline.selected:not(.free) .secondaryOutline{
            stroke:#0060df;
            stroke:var(--outline-color);
            stroke-width:2px;
            stroke-width:var(--outline-width);
          }

.canvasWrapper svg.highlightOutline.free.hovered:not(.selected){
          stroke:#8f8f9d;
          stroke:var(--hover-outline-color);
          stroke-width:calc(2 * 2px);
          stroke-width:calc(2 * var(--outline-width));
        }

.canvasWrapper svg.highlightOutline.free.selected .mainOutline{
            stroke:#f0f0f4;
            stroke:var(--outline-around-color);
            stroke-width:calc(
              2 * (2px + 1px)
            );
            stroke-width:calc(
              2 * (var(--outline-width) + var(--outline-around-width))
            );
          }

.canvasWrapper svg.highlightOutline.free.selected .secondaryOutline{
            stroke:#0060df;
            stroke:var(--outline-color);
            stroke-width:calc(2 * 2px);
            stroke-width:calc(2 * var(--outline-width));
          }

.toggle-button{
  --button-background-color:#f0f0f4;
  --button-background-color-hover:#e0e0e6;
  --button-background-color-active:#cfcfd8;
  --color-accent-primary:#0060df;
  --color-accent-primary-hover:#0250bb;
  --color-accent-primary-active:#054096;
  --border-interactive-color:#8f8f9d;
  --border-radius-circle:9999px;
  --border-width:1px;
  --size-item-small:16px;
  --size-item-large:32px;
  --color-canvas:white;

  --toggle-background-color:var(--button-background-color);
  --toggle-background-color-hover:var(--button-background-color-hover);
  --toggle-background-color-active:var(--button-background-color-active);
  --toggle-background-color-pressed:var(--color-accent-primary);
  --toggle-background-color-pressed-hover:var(--color-accent-primary-hover);
  --toggle-background-color-pressed-active:var(--color-accent-primary-active);
  --toggle-border-color:var(--border-interactive-color);
  --toggle-border-color-hover:var(--toggle-border-color);
  --toggle-border-color-active:var(--toggle-border-color);
  --toggle-border-radius:var(--border-radius-circle);
  --toggle-border-width:var(--border-width);
  --toggle-height:var(--size-item-small);
  --toggle-width:var(--size-item-large);
  --toggle-dot-background-color:var(--toggle-border-color);
  --toggle-dot-background-color-hover:var(--toggle-dot-background-color);
  --toggle-dot-background-color-active:var(--toggle-dot-background-color);
  --toggle-dot-background-color-on-pressed:var(--color-canvas);
  --toggle-dot-margin:1px;
  --toggle-dot-height:calc(
    var(--toggle-height) - 2 * var(--toggle-dot-margin) - 2 *
      var(--toggle-border-width)
  );
  --toggle-dot-width:var(--toggle-dot-height);
  --toggle-dot-transform-x:calc(
    var(--toggle-width) - 4 * var(--toggle-dot-margin) - var(--toggle-dot-width)
  );

  -webkit-appearance:none;

          appearance:none;
  padding:0;
  margin:0;
  border:var(--toggle-border-width) solid var(--toggle-border-color);
  height:var(--toggle-height);
  width:var(--toggle-width);
  border-radius:var(--toggle-border-radius);
  background:var(--toggle-background-color);
  box-sizing:border-box;
  flex-shrink:0;
}

@media (prefers-color-scheme: dark){

.toggle-button{
    --button-background-color:color-mix(in srgb, currentColor 7%, transparent);
    --button-background-color-hover:color-mix(
      in srgb,
      currentColor 14%,
      transparent
    );
    --button-background-color-active:color-mix(
      in srgb,
      currentColor 21%,
      transparent
    );
    --color-accent-primary:#0df;
    --color-accent-primary-hover:#80ebff;
    --color-accent-primary-active:#aaf2ff;
    --border-interactive-color:#bfbfc9;
    --color-canvas:#1c1b22;
}
  }

@media (forced-colors: active){

.toggle-button{
    --color-accent-primary:ButtonText;
    --color-accent-primary-hover:SelectedItem;
    --color-accent-primary-active:SelectedItem;
    --border-interactive-color:ButtonText;
    --button-background-color:ButtonFace;
    --border-interactive-color-hover:SelectedItem;
    --border-interactive-color-active:SelectedItem;
    --border-interactive-color-disabled:GrayText;
    --color-canvas:ButtonText;
}
  }

.toggle-button:focus-visible{
    outline:solid 2px #0060df;
    outline:var(--focus-outline);
    outline-offset:var(--focus-outline-offset);
  }

.toggle-button:enabled:hover{
    background:var(--toggle-background-color-hover);
    border-color:var(--toggle-border-color);
  }

.toggle-button:enabled:active{
    background:var(--toggle-background-color-active);
    border-color:var(--toggle-border-color);
  }

.toggle-button[aria-pressed="true"]{
    background:var(--toggle-background-color-pressed);
    border-color:transparent;
  }

.toggle-button[aria-pressed="true"]:enabled:hover{
    background:var(--toggle-background-color-pressed-hover);
    border-color:transparent;
  }

.toggle-button[aria-pressed="true"]:enabled:active{
    background:var(--toggle-background-color-pressed-active);
    border-color:transparent;
  }

.toggle-button::before{
    display:block;
    content:"";
    background-color:var(--toggle-dot-background-color);
    height:var(--toggle-dot-height);
    width:var(--toggle-dot-width);
    margin:var(--toggle-dot-margin);
    border-radius:var(--toggle-border-radius);
    translate:0;
  }

.toggle-button[aria-pressed="true"]::before{
    translate:var(--toggle-dot-transform-x);
    background-color:var(--toggle-dot-background-color-on-pressed);
  }

.toggle-button[aria-pressed="true"]:enabled:hover::before,
  .toggle-button[aria-pressed="true"]:enabled:active::before{
    background-color:var(--toggle-dot-background-color-on-pressed);
  }

[dir="rtl"] .toggle-button[aria-pressed="true"]::before{
    translate:calc(-1 * var(--toggle-dot-transform-x));
  }

@media (prefers-reduced-motion: no-preference){
    .toggle-button::before{
      transition:translate 100ms;
    }
  }

@media (prefers-contrast){
    .toggle-button:enabled:hover{
      border-color:var(--toggle-border-color-hover);
    }

    .toggle-button:enabled:active{
      border-color:var(--toggle-border-color-active);
    }

    .toggle-button[aria-pressed="true"]:enabled{
      border-color:var(--toggle-border-color);
      position:relative;
    }

    .toggle-button[aria-pressed="true"]:enabled:hover,
    .toggle-button[aria-pressed="true"]:enabled:hover:active{
      border-color:var(--toggle-border-color-hover);
    }

    .toggle-button[aria-pressed="true"]:enabled:active{
      background-color:var(--toggle-dot-background-color-active);
      border-color:var(--toggle-dot-background-color-hover);
    }

    .toggle-button:hover::before,
    .toggle-button:active::before{
      background-color:var(--toggle-dot-background-color-hover);
    }
  }

@media (forced-colors){

.toggle-button{
    --toggle-dot-background-color:var(--color-accent-primary);
    --toggle-dot-background-color-hover:var(--color-accent-primary-hover);
    --toggle-dot-background-color-active:var(--color-accent-primary-active);
    --toggle-dot-background-color-on-pressed:var(--button-background-color);
    --toggle-background-color-disabled:var(--button-background-color-disabled);
    --toggle-border-color-hover:var(--border-interactive-color-hover);
    --toggle-border-color-active:var(--border-interactive-color-active);
    --toggle-border-color-disabled:var(--border-interactive-color-disabled);
}

    .toggle-button[aria-pressed="true"]:enabled::after{
      border:1px solid var(--button-background-color);
      content:"";
      position:absolute;
      height:var(--toggle-height);
      width:var(--toggle-width);
      display:block;
      border-radius:var(--toggle-border-radius);
      inset:-2px;
    }

    .toggle-button[aria-pressed="true"]:enabled:active::after{
      border-color:var(--toggle-border-color-active);
    }
  }

:root{
  --outline-width:2px;
  --outline-color:#0060df;
  --outline-around-width:1px;
  --outline-around-color:#f0f0f4;
  --hover-outline-around-color:var(--outline-around-color);
  --focus-outline:solid var(--outline-width) var(--outline-color);
  --unfocus-outline:solid var(--outline-width) transparent;
  --focus-outline-around:solid var(--outline-around-width) var(--outline-around-color);
  --hover-outline-color:#8f8f9d;
  --hover-outline:solid var(--outline-width) var(--hover-outline-color);
  --hover-outline-around:solid var(--outline-around-width) var(--hover-outline-around-color);
  --freetext-line-height:1.35;
  --freetext-padding:2px;
  --resizer-bg-color:var(--outline-color);
  --resizer-size:6px;
  --resizer-shift:calc(
    0px - (var(--outline-width) + var(--resizer-size)) / 2 -
      var(--outline-around-width)
  );
  --editorFreeText-editing-cursor:text;
  --editorInk-editing-cursor:url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 16, pointer;
  --editorHighlight-editing-cursor:url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 24 24, text;
  --editorFreeHighlight-editing-cursor:url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 1 18, pointer;
}
.visuallyHidden{
  position:absolute;
  top:0;
  left:0;
  border:0;
  margin:0;
  padding:0;
  width:0;
  height:0;
  overflow:hidden;
  white-space:nowrap;
  font-size:0;
}

.textLayer.highlighting{
  cursor:url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 1 18, pointer;
  cursor:var(--editorFreeHighlight-editing-cursor);
}

.textLayer.highlighting:not(.free) span{
    cursor:url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 24 24, text;
    cursor:var(--editorHighlight-editing-cursor);
  }

.textLayer.highlighting.free span{
    cursor:url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 1 18, pointer;
    cursor:var(--editorFreeHighlight-editing-cursor);
  }

@media (-webkit-min-device-pixel-ratio: 1.1), (min-resolution: 1.1dppx){
  :root{
    --editorFreeText-editing-cursor:url(${___CSS_LOADER_URL_REPLACEMENT_3___}) 0 16, text;
  }
}

@media screen and (forced-colors: active){
  :root{
    --outline-color:CanvasText;
    --outline-around-color:ButtonFace;
    --resizer-bg-color:ButtonText;
    --hover-outline-color:Highlight;
    --hover-outline-around-color:SelectedItemText;
  }
}

[data-editor-rotation="90"]{
  transform:rotate(90deg);
}

[data-editor-rotation="180"]{
  transform:rotate(180deg);
}

[data-editor-rotation="270"]{
  transform:rotate(270deg);
}

.annotationEditorLayer{
  background:transparent;
  position:absolute;
  inset:0;
  font-size:calc(100px * var(--scale-factor));
  transform-origin:0 0;
  cursor:auto;
}

.annotationEditorLayer.waiting{
  content:"";
  cursor:wait;
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
}

.annotationEditorLayer.disabled{
  pointer-events:none;
}

.annotationEditorLayer.freetextEditing{
  cursor:text;
  cursor:var(--editorFreeText-editing-cursor);
}

.annotationEditorLayer.inkEditing{
  cursor:url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 16, pointer;
  cursor:var(--editorInk-editing-cursor);
}

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor){
  position:absolute;
  background:transparent;
  z-index:1;
  transform-origin:0 0;
  cursor:auto;
  max-width:100%;
  max-height:100%;
  border:solid 2px transparent;
  border:var(--unfocus-outline);
}

.annotationEditorLayer .draggable.selectedEditor:is(.freeTextEditor, .inkEditor, .stampEditor){
    cursor:move;
  }

.annotationEditorLayer .moving:is(.freeTextEditor, .inkEditor, .stampEditor){
    touch-action:none;
  }

.annotationEditorLayer .selectedEditor:is(.freeTextEditor, .inkEditor, .stampEditor){
    border:solid 2px #0060df;
    border:var(--focus-outline);
    outline:solid 1px #f0f0f4;
    outline:var(--focus-outline-around);
  }

.annotationEditorLayer .selectedEditor:is(.freeTextEditor, .inkEditor, .stampEditor)::before{
      content:"";
      position:absolute;
      inset:0;
      border:solid 1px #f0f0f4;
      border:var(--focus-outline-around);
      pointer-events:none;
    }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor):hover:not(.selectedEditor){
    border:solid 2px #8f8f9d;
    border:var(--hover-outline);
    outline:solid 1px #f0f0f4;
    outline:var(--hover-outline-around);
  }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor):hover:not(.selectedEditor)::before{
      content:"";
      position:absolute;
      inset:0;
      border:solid 1px #f0f0f4;
      border:var(--focus-outline-around);
    }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{
    --editor-toolbar-delete-image:url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    --editor-toolbar-bg-color:#f0f0f4;
    --editor-toolbar-highlight-image:url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    --editor-toolbar-fg-color:#2e2e56;
    --editor-toolbar-border-color:#8f8f9d;
    --editor-toolbar-hover-border-color:var(--editor-toolbar-border-color);
    --editor-toolbar-hover-bg-color:#e0e0e6;
    --editor-toolbar-hover-fg-color:var(--editor-toolbar-fg-color);
    --editor-toolbar-hover-outline:none;
    --editor-toolbar-focus-outline-color:#0060df;
    --editor-toolbar-shadow:0 2px 6px 0 rgb(58 57 68 / 0.2);
    --editor-toolbar-vert-offset:6px;
    --editor-toolbar-height:28px;
    --editor-toolbar-padding:2px;

    display:flex;
    width:-moz-fit-content;
    width:-webkit-fit-content;
    width:fit-content;
    height:var(--editor-toolbar-height);
    flex-direction:column;
    justify-content:center;
    align-items:center;
    cursor:default;
    pointer-events:auto;
    box-sizing:content-box;
    padding:var(--editor-toolbar-padding);

    position:absolute;
    inset-inline-end:0;
    inset-block-start:calc(100% + var(--editor-toolbar-vert-offset));

    border-radius:6px;
    background-color:var(--editor-toolbar-bg-color);
    border:1px solid var(--editor-toolbar-border-color);
    box-shadow:var(--editor-toolbar-shadow);
  }

@media (prefers-color-scheme: dark){

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{
      --editor-toolbar-bg-color:#2b2a33;
      --editor-toolbar-fg-color:#fbfbfe;
      --editor-toolbar-hover-bg-color:#52525e;
      --editor-toolbar-focus-outline-color:#0df;
  }
    }

@media screen and (forced-colors: active){

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{
      --editor-toolbar-bg-color:ButtonFace;
      --editor-toolbar-fg-color:ButtonText;
      --editor-toolbar-border-color:ButtonText;
      --editor-toolbar-hover-border-color:AccentColor;
      --editor-toolbar-hover-bg-color:ButtonFace;
      --editor-toolbar-hover-fg-color:AccentColor;
      --editor-toolbar-hover-outline:2px solid var(--editor-toolbar-hover-border-color);
      --editor-toolbar-focus-outline-color:ButtonBorder;
      --editor-toolbar-shadow:none;
  }
    }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar.hidden{
      display:none;
    }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar:has(:focus-visible){
      border-color:transparent;
    }

[dir="ltr"] :is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{
      transform-origin:100% 0;
    }

[dir="rtl"] :is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{
      transform-origin:0 0;
    }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons{
      display:flex;
      justify-content:center;
      align-items:center;
      gap:0;
      height:100%;
    }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .divider{
        width:1px;
        height:calc(
          2 * var(--editor-toolbar-padding) + var(--editor-toolbar-height)
        );
        background-color:var(--editor-toolbar-border-color);
        display:inline-block;
        margin-inline:2px;
      }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .highlightButton{
        width:var(--editor-toolbar-height);
      }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .highlightButton::before{
          content:"";
          -webkit-mask-image:var(--editor-toolbar-highlight-image);
                  mask-image:var(--editor-toolbar-highlight-image);
          -webkit-mask-repeat:no-repeat;
                  mask-repeat:no-repeat;
          -webkit-mask-position:center;
                  mask-position:center;
          display:inline-block;
          background-color:var(--editor-toolbar-fg-color);
          width:100%;
          height:100%;
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .highlightButton:hover::before{
          background-color:var(--editor-toolbar-hover-fg-color);
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .delete{
        width:var(--editor-toolbar-height);
      }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .delete::before{
          content:"";
          -webkit-mask-image:var(--editor-toolbar-delete-image);
                  mask-image:var(--editor-toolbar-delete-image);
          -webkit-mask-repeat:no-repeat;
                  mask-repeat:no-repeat;
          -webkit-mask-position:center;
                  mask-position:center;
          display:inline-block;
          background-color:var(--editor-toolbar-fg-color);
          width:100%;
          height:100%;
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .delete:hover::before{
          background-color:var(--editor-toolbar-hover-fg-color);
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > *{
        height:var(--editor-toolbar-height);
      }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > :not(.divider){
        border:none;
        background-color:transparent;
        cursor:pointer;
      }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > :not(.divider):hover{
          border-radius:2px;
          background-color:var(--editor-toolbar-hover-bg-color);
          color:var(--editor-toolbar-hover-fg-color);
          outline:var(--editor-toolbar-hover-outline);
          outline-offset:1px;
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > :not(.divider):hover:active{
            outline:none;
          }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > :not(.divider):focus-visible{
          border-radius:2px;
          outline:2px solid var(--editor-toolbar-focus-outline-color);
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText{
        --alt-text-add-image:url(${___CSS_LOADER_URL_REPLACEMENT_6___});
        --alt-text-done-image:url(${___CSS_LOADER_URL_REPLACEMENT_7___});

        display:flex;
        align-items:center;
        justify-content:center;
        width:-webkit-max-content;
        width:max-content;
        padding-inline:8px;
        pointer-events:all;
        font:menu;
        font-weight:590;
        font-size:12px;
        color:var(--editor-toolbar-fg-color);
      }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText:disabled{
          pointer-events:none;
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText::before{
          content:"";
          -webkit-mask-image:var(--alt-text-add-image);
                  mask-image:var(--alt-text-add-image);
          -webkit-mask-repeat:no-repeat;
                  mask-repeat:no-repeat;
          -webkit-mask-position:center;
                  mask-position:center;
          display:inline-block;
          width:12px;
          height:13px;
          background-color:var(--editor-toolbar-fg-color);
          margin-inline-end:4px;
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText:hover::before{
          background-color:var(--editor-toolbar-hover-fg-color);
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText.done::before{
          -webkit-mask-image:var(--alt-text-done-image);
                  mask-image:var(--alt-text-done-image);
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText .tooltip{
          display:none;
        }

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText .tooltip.show{
            --alt-text-tooltip-bg:#f0f0f4;
            --alt-text-tooltip-fg:#15141a;
            --alt-text-tooltip-border:#8f8f9d;
            --alt-text-tooltip-shadow:0px 2px 6px 0px rgb(58 57 68 / 0.2);

            display:inline-flex;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            position:absolute;
            top:calc(100% + 2px);
            inset-inline-start:0;
            padding-block:2px 3px;
            padding-inline:3px;
            max-width:300px;
            width:-webkit-max-content;
            width:max-content;
            height:auto;
            font-size:12px;

            border:0.5px solid var(--alt-text-tooltip-border);
            background:var(--alt-text-tooltip-bg);
            box-shadow:var(--alt-text-tooltip-shadow);
            color:var(--alt-text-tooltip-fg);

            pointer-events:none;
          }

@media (prefers-color-scheme: dark){

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText .tooltip.show{
              --alt-text-tooltip-bg:#1c1b22;
              --alt-text-tooltip-fg:#fbfbfe;
              --alt-text-tooltip-shadow:0px 2px 6px 0px #15141a;
          }
            }

@media screen and (forced-colors: active){

:is(.annotationEditorLayer
  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText .tooltip.show{
              --alt-text-tooltip-bg:Canvas;
              --alt-text-tooltip-fg:CanvasText;
              --alt-text-tooltip-border:CanvasText;
              --alt-text-tooltip-shadow:none;
          }
            }

.annotationEditorLayer .freeTextEditor{
  padding:calc(2px * var(--scale-factor));
  padding:calc(var(--freetext-padding) * var(--scale-factor));
  width:auto;
  height:auto;
  touch-action:none;
}

.annotationEditorLayer .freeTextEditor .internal{
  background:transparent;
  border:none;
  inset:0;
  overflow:visible;
  white-space:nowrap;
  font:10px sans-serif;
  line-height:1.35;
  line-height:var(--freetext-line-height);
  -webkit-user-select:none;
          user-select:none;
}

.annotationEditorLayer .freeTextEditor .overlay{
  position:absolute;
  display:none;
  background:transparent;
  inset:0;
  width:100%;
  height:100%;
}

.annotationEditorLayer freeTextEditor .overlay.enabled{
  display:block;
}

.annotationEditorLayer .freeTextEditor .internal:empty::before{
  content:attr(default-content);
  color:gray;
}

.annotationEditorLayer .freeTextEditor .internal:focus{
  outline:none;
  -webkit-user-select:auto;
          user-select:auto;
}

.annotationEditorLayer .inkEditor{
  width:100%;
  height:100%;
}

.annotationEditorLayer .inkEditor.editing{
  cursor:inherit;
}

.annotationEditorLayer .inkEditor .inkEditorCanvas{
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
  touch-action:none;
}

.annotationEditorLayer .stampEditor{
  width:auto;
  height:auto;
}

.annotationEditorLayer .stampEditor canvas{
    position:absolute;
    width:100%;
    height:100%;
    margin:0;
  }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers{
      position:absolute;
      inset:0;
    }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers.hidden{
        display:none;
      }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer{
        width:6px;
        width:var(--resizer-size);
        height:6px;
        height:var(--resizer-size);
        background:content-box #0060df;
        background:content-box var(--resizer-bg-color);
        border:solid 1px #f0f0f4;
        border:var(--focus-outline-around);
        border-radius:2px;
        position:absolute;
      }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.topLeft{
          top:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          top:var(--resizer-shift);
          left:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          left:var(--resizer-shift);
        }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.topMiddle{
          top:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          top:var(--resizer-shift);
          left:calc(50% + calc(
    0px - (2px + 6px) / 2 -
      1px
  ));
          left:calc(50% + var(--resizer-shift));
        }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.topRight{
          top:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          top:var(--resizer-shift);
          right:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          right:var(--resizer-shift);
        }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.middleRight{
          top:calc(50% + calc(
    0px - (2px + 6px) / 2 -
      1px
  ));
          top:calc(50% + var(--resizer-shift));
          right:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          right:var(--resizer-shift);
        }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.bottomRight{
          bottom:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          bottom:var(--resizer-shift);
          right:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          right:var(--resizer-shift);
        }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.bottomMiddle{
          bottom:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          bottom:var(--resizer-shift);
          left:calc(50% + calc(
    0px - (2px + 6px) / 2 -
      1px
  ));
          left:calc(50% + var(--resizer-shift));
        }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.bottomLeft{
          bottom:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          bottom:var(--resizer-shift);
          left:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          left:var(--resizer-shift);
        }

.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.middleLeft{
          top:calc(50% + calc(
    0px - (2px + 6px) / 2 -
      1px
  ));
          top:calc(50% + var(--resizer-shift));
          left:calc(
    0px - (2px + 6px) / 2 -
      1px
  );
          left:var(--resizer-shift);
        }

.annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.topLeft,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.topLeft,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.topLeft,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.topLeft,
      .annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.bottomRight,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.bottomRight,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.bottomRight,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.bottomRight{
        cursor:nwse-resize;
      }

.annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.topMiddle,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.topMiddle,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.topMiddle,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.topMiddle,
      .annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.bottomMiddle,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.bottomMiddle,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.bottomMiddle,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.bottomMiddle{
        cursor:ns-resize;
      }

.annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.topRight,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.topRight,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.topRight,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.topRight,
      .annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.bottomLeft,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.bottomLeft,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.bottomLeft,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.bottomLeft{
        cursor:nesw-resize;
      }

.annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.middleRight,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.middleRight,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.middleRight,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.middleRight,
      .annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.middleLeft,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.middleLeft,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.middleLeft,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.middleLeft{
        cursor:ew-resize;
      }

.annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.topLeft,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.topLeft,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.topLeft,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.topLeft,
      .annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.bottomRight,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.bottomRight,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.bottomRight,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.bottomRight{
        cursor:nesw-resize;
      }

.annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.topMiddle,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.topMiddle,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.topMiddle,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.topMiddle,
      .annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.bottomMiddle,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.bottomMiddle,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.bottomMiddle,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.bottomMiddle{
        cursor:ew-resize;
      }

.annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.topRight,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.topRight,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.topRight,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.topRight,
      .annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.bottomLeft,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.bottomLeft,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.bottomLeft,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.bottomLeft{
        cursor:nwse-resize;
      }

.annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.middleRight,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.middleRight,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.middleRight,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.middleRight,
      .annotationEditorLayer[data-main-rotation="0"]
    :is([data-editor-rotation="90"], [data-editor-rotation="270"]) > .resizers > .resizer.middleLeft,
      .annotationEditorLayer[data-main-rotation="90"]
    :is([data-editor-rotation="0"], [data-editor-rotation="180"]) > .resizers > .resizer.middleLeft,
      .annotationEditorLayer[data-main-rotation="180"]
    :is([data-editor-rotation="270"], [data-editor-rotation="90"]) > .resizers > .resizer.middleLeft,
      .annotationEditorLayer[data-main-rotation="270"]
    :is([data-editor-rotation="180"], [data-editor-rotation="0"]) > .resizers > .resizer.middleLeft{
        cursor:ns-resize;
      }

.annotationEditorLayer
    :is(
      [data-main-rotation="0"] [data-editor-rotation="90"],
      [data-main-rotation="90"] [data-editor-rotation="0"],
      [data-main-rotation="180"] [data-editor-rotation="270"],
      [data-main-rotation="270"] [data-editor-rotation="180"]
    ) .editToolbar{
      rotate:270deg;
    }

[dir="ltr"] .annotationEditorLayer
    :is(
      [data-main-rotation="0"] [data-editor-rotation="90"],
      [data-main-rotation="90"] [data-editor-rotation="0"],
      [data-main-rotation="180"] [data-editor-rotation="270"],
      [data-main-rotation="270"] [data-editor-rotation="180"]
    ) .editToolbar{
        inset-inline-end:calc(0px - var(--editor-toolbar-vert-offset));
        inset-block-start:0;
      }

[dir="rtl"] .annotationEditorLayer
    :is(
      [data-main-rotation="0"] [data-editor-rotation="90"],
      [data-main-rotation="90"] [data-editor-rotation="0"],
      [data-main-rotation="180"] [data-editor-rotation="270"],
      [data-main-rotation="270"] [data-editor-rotation="180"]
    ) .editToolbar{
        inset-inline-end:calc(100% + var(--editor-toolbar-vert-offset));
        inset-block-start:0;
      }

.annotationEditorLayer
    :is(
      [data-main-rotation="0"] [data-editor-rotation="180"],
      [data-main-rotation="90"] [data-editor-rotation="90"],
      [data-main-rotation="180"] [data-editor-rotation="0"],
      [data-main-rotation="270"] [data-editor-rotation="270"]
    ) .editToolbar{
      rotate:180deg;
      inset-inline-end:100%;
      inset-block-start:calc(0pc - var(--editor-toolbar-vert-offset));
    }

.annotationEditorLayer
    :is(
      [data-main-rotation="0"] [data-editor-rotation="270"],
      [data-main-rotation="90"] [data-editor-rotation="180"],
      [data-main-rotation="180"] [data-editor-rotation="90"],
      [data-main-rotation="270"] [data-editor-rotation="0"]
    ) .editToolbar{
      rotate:90deg;
    }

[dir="ltr"] .annotationEditorLayer
    :is(
      [data-main-rotation="0"] [data-editor-rotation="270"],
      [data-main-rotation="90"] [data-editor-rotation="180"],
      [data-main-rotation="180"] [data-editor-rotation="90"],
      [data-main-rotation="270"] [data-editor-rotation="0"]
    ) .editToolbar{
        inset-inline-end:calc(100% + var(--editor-toolbar-vert-offset));
        inset-block-start:100%;
      }

[dir="rtl"] .annotationEditorLayer
    :is(
      [data-main-rotation="0"] [data-editor-rotation="270"],
      [data-main-rotation="90"] [data-editor-rotation="180"],
      [data-main-rotation="180"] [data-editor-rotation="90"],
      [data-main-rotation="270"] [data-editor-rotation="0"]
    ) .editToolbar{
        inset-inline-start:calc(0px - var(--editor-toolbar-vert-offset));
        inset-block-start:0;
      }

.dialog.altText::backdrop{
    -webkit-mask:url(#alttext-manager-mask);
            mask:url(#alttext-manager-mask);
  }

.dialog.altText.positioned{
    margin:0;
  }

.dialog.altText #altTextContainer{
    width:300px;
    height:-moz-fit-content;
    height:-webkit-fit-content;
    height:fit-content;
    display:inline-flex;
    flex-direction:column;
    align-items:flex-start;
    gap:16px;
  }

.dialog.altText #altTextContainer #overallDescription{
      display:flex;
      flex-direction:column;
      align-items:flex-start;
      gap:4px;
      align-self:stretch;
    }

.dialog.altText #altTextContainer #overallDescription span{
        align-self:stretch;
      }

.dialog.altText #altTextContainer #overallDescription .title{
        font-size:13px;
        font-style:normal;
        font-weight:590;
      }

.dialog.altText #altTextContainer #addDescription{
      display:flex;
      flex-direction:column;
      align-items:stretch;
      gap:8px;
    }

.dialog.altText #altTextContainer #addDescription .descriptionArea{
        flex:1 1;
        padding-inline:24px 10px;
      }

.dialog.altText #altTextContainer #addDescription .descriptionArea textarea{
          width:100%;
          min-height:75px;
        }

.dialog.altText #altTextContainer #buttons{
      display:flex;
      justify-content:flex-end;
      align-items:flex-start;
      gap:8px;
      align-self:stretch;
    }

.colorPicker{
  --hover-outline-color:#0250bb;
  --selected-outline-color:#0060df;
  --swatch-border-color:#cfcfd8;
}

@media (prefers-color-scheme: dark){

.colorPicker{
    --hover-outline-color:#80ebff;
    --selected-outline-color:#aaf2ff;
    --swatch-border-color:#52525e;
}
  }

@media screen and (forced-colors: active){

.colorPicker{
    --hover-outline-color:Highlight;
    --selected-outline-color:var(--hover-outline-color);
    --swatch-border-color:ButtonText;
}
  }

.colorPicker .swatch{
    width:16px;
    height:16px;
    border:1px solid var(--swatch-border-color);
    border-radius:100%;
    outline-offset:2px;
    box-sizing:border-box;
    forced-color-adjust:none;
  }

.colorPicker button:is(:hover, .selected) > .swatch{
    border:none;
  }

.annotationEditorLayer[data-main-rotation="0"] .highlightEditor:not(.free) > .editToolbar{
      rotate:0deg;
    }

.annotationEditorLayer[data-main-rotation="90"] .highlightEditor:not(.free) > .editToolbar{
      rotate:270deg;
    }

.annotationEditorLayer[data-main-rotation="180"] .highlightEditor:not(.free) > .editToolbar{
      rotate:180deg;
    }

.annotationEditorLayer[data-main-rotation="270"] .highlightEditor:not(.free) > .editToolbar{
      rotate:90deg;
    }

.annotationEditorLayer .highlightEditor{
    position:absolute;
    background:transparent;
    z-index:1;
    cursor:auto;
    max-width:100%;
    max-height:100%;
    border:none;
    outline:none;
    pointer-events:none;
    transform-origin:0 0;
  }

.annotationEditorLayer .highlightEditor:not(.free){
      transform:none;
    }

.annotationEditorLayer .highlightEditor .internal{
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      pointer-events:auto;
    }

.annotationEditorLayer .highlightEditor.disabled .internal{
      pointer-events:none;
    }

.annotationEditorLayer .highlightEditor.selectedEditor .internal{
        cursor:pointer;
      }

.annotationEditorLayer .highlightEditor .editToolbar{
      --editor-toolbar-colorpicker-arrow-image:url(${___CSS_LOADER_URL_REPLACEMENT_8___});

      transform-origin:center !important;
    }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker{
          position:relative;
          width:auto;
          display:flex;
          justify-content:center;
          align-items:center;
          gap:4px;
          padding:4px;
        }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker::after{
            content:"";
            -webkit-mask-image:var(--editor-toolbar-colorpicker-arrow-image);
                    mask-image:var(--editor-toolbar-colorpicker-arrow-image);
            -webkit-mask-repeat:no-repeat;
                    mask-repeat:no-repeat;
            -webkit-mask-position:center;
                    mask-position:center;
            display:inline-block;
            background-color:var(--editor-toolbar-fg-color);
            width:12px;
            height:12px;
          }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker:hover::after{
            background-color:var(--editor-toolbar-hover-fg-color);
          }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker:has(.dropdown:not(.hidden)){
            background-color:var(--editor-toolbar-hover-bg-color);
          }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker:has(.dropdown:not(.hidden))::after{
              scale:-1;
            }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown{
            position:absolute;
            display:flex;
            justify-content:center;
            align-items:center;
            flex-direction:column;
            gap:11px;
            padding-block:8px;
            border-radius:6px;
            background-color:var(--editor-toolbar-bg-color);
            border:1px solid var(--editor-toolbar-border-color);
            box-shadow:var(--editor-toolbar-shadow);
            inset-block-start:calc(100% + 4px);
            width:calc(100% + 2 * var(--editor-toolbar-padding));
          }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button{
              width:100%;
              height:auto;
              border:none;
              cursor:pointer;
              display:flex;
              justify-content:center;
              align-items:center;
              background:none;
            }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button:is(:active, :focus-visible){
                outline:none;
              }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button > .swatch{
                outline-offset:2px;
              }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button[aria-selected="true"] > .swatch{
                outline:2px solid var(--selected-outline-color);
              }

.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button:is(:hover, :active, :focus-visible) > .swatch{
                outline:2px solid #8f8f9d;
                outline:2px solid var(--hover-outline-color);
              }

.editorParamsToolbar:has(#highlightParamsToolbarContainer){
  padding:0;
  padding:initial;
}

#highlightParamsToolbarContainer{
  height:auto;
  padding-inline:10px;
  padding-block:10px 16px;
  gap:16px;
  display:flex;
  flex-direction:column;
  box-sizing:border-box;
}

#highlightParamsToolbarContainer .editorParamsLabel{
    width:-moz-fit-content;
    width:-webkit-fit-content;
    width:fit-content;
    inset-inline-start:0;
  }

#highlightParamsToolbarContainer .colorPicker{
    display:flex;
    flex-direction:column;
    gap:8px;
  }

#highlightParamsToolbarContainer .colorPicker .dropdown{
      display:flex;
      justify-content:space-between;
      align-items:center;
      flex-direction:row;
      height:auto;
    }

#highlightParamsToolbarContainer .colorPicker .dropdown button{
        width:auto;
        height:auto;
        border:none;
        cursor:pointer;
        display:flex;
        justify-content:center;
        align-items:center;
        background:none;
        flex:0 0 auto;
      }

#highlightParamsToolbarContainer .colorPicker .dropdown button .swatch{
          width:24px;
          height:24px;
        }

#highlightParamsToolbarContainer .colorPicker .dropdown button:is(:active, :focus-visible){
          outline:none;
        }

#highlightParamsToolbarContainer .colorPicker .dropdown button[aria-selected="true"] > .swatch{
          outline:2px solid var(--selected-outline-color);
        }

#highlightParamsToolbarContainer .colorPicker .dropdown button:is(:hover, :active, :focus-visible) > .swatch{
          outline:2px solid #8f8f9d;
          outline:2px solid var(--hover-outline-color);
        }

#highlightParamsToolbarContainer #editorHighlightThickness{
    display:flex;
    flex-direction:column;
    align-items:center;
    gap:4px;
    align-self:stretch;
  }

#highlightParamsToolbarContainer #editorHighlightThickness .editorParamsLabel{
      width:100%;
      height:auto;
      align-self:stretch;
    }

#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker{
      display:flex;
      justify-content:space-between;
      align-items:center;
      align-self:stretch;

      --example-color:#bfbfc9;
    }

@media (prefers-color-scheme: dark){

#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker{
        --example-color:#80808e;
    }
      }

@media screen and (forced-colors: active){

#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker{
        --example-color:CanvasText;
    }
      }

:is(#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker > .editorParamsSlider[disabled]){
        opacity:0.4;
      }

#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker::before,
      #highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker::after{
        content:"";
        width:8px;
        aspect-ratio:1;
        display:block;
        border-radius:100%;
        background-color:var(--example-color);
      }

#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker::after{
        width:24px;
      }

#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker .editorParamsSlider{
        width:auto;
        width:initial;
        height:14px;
      }

#highlightParamsToolbarContainer #editorHighlightVisibility{
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    gap:8px;
    align-self:stretch;
  }

#highlightParamsToolbarContainer #editorHighlightVisibility .divider{
      --divider-color:#d7d7db;

      margin-block:4px;
      width:100%;
      height:1px;
      background-color:var(--divider-color);
    }

@media (prefers-color-scheme: dark){

#highlightParamsToolbarContainer #editorHighlightVisibility .divider{
        --divider-color:#8f8f9d;
    }
      }

@media screen and (forced-colors: active){

#highlightParamsToolbarContainer #editorHighlightVisibility .divider{
        --divider-color:CanvasText;
    }
      }

#highlightParamsToolbarContainer #editorHighlightVisibility .toggler{
      display:flex;
      justify-content:space-between;
      align-items:center;
      align-self:stretch;
    }

:root{
  --viewer-container-height:0;
  --pdfViewer-padding-bottom:0;
  --page-margin:1px auto -8px;
  --page-border:9px solid transparent;
  --spreadHorizontalWrapped-margin-LR:-3.5px;
  --loading-icon-delay:400ms;
}

@media screen and (forced-colors: active){
  :root{
    --pdfViewer-padding-bottom:9px;
    --page-margin:8px auto -1px;
    --page-border:1px solid CanvasText;
    --spreadHorizontalWrapped-margin-LR:3.5px;
  }
}

[data-main-rotation="90"]{
  transform:rotate(90deg) translateY(-100%);
}
[data-main-rotation="180"]{
  transform:rotate(180deg) translate(-100%, -100%);
}
[data-main-rotation="270"]{
  transform:rotate(270deg) translateX(-100%);
}

#hiddenCopyElement,
.hiddenCanvasElement{
  position:absolute;
  top:0;
  left:0;
  width:0;
  height:0;
  display:none;
}

.pdfViewer{
  --scale-factor:1;

  padding-bottom:0;

  padding-bottom:var(--pdfViewer-padding-bottom);

  --hcm-highlight-filter:none;
  --hcm-highlight-selected-filter:none;
}

@media screen and (forced-colors: active){

.pdfViewer{
    --hcm-highlight-filter:invert(100%);
}
  }

.pdfViewer .canvasWrapper{
    overflow:hidden;
    width:100%;
    height:100%;
  }

.pdfViewer .canvasWrapper canvas{
      margin:0;
      display:block;
    }

.pdfViewer .canvasWrapper canvas[hidden]{
        display:none;
      }

.pdfViewer .canvasWrapper canvas[zooming]{
        width:100%;
        height:100%;
      }

.pdfViewer .canvasWrapper canvas .structTree{
        contain:strict;
      }

.pdfViewer .page{
  direction:ltr;
  width:816px;
  height:1056px;
  margin:1px auto -8px;
  margin:var(--page-margin);
  position:relative;
  overflow:visible;
  border:9px solid transparent;
  border:var(--page-border);
  background-clip:content-box;
  background-color:rgb(255 255 255);
}

.pdfViewer .dummyPage{
  position:relative;
  width:0;
  height:0;
  height:var(--viewer-container-height);
}

.pdfViewer.noUserSelect{
  -webkit-user-select:none;
          user-select:none;
}

.pdfViewer.removePageBorders .page{
  margin:0 auto 10px;
  border:none;
}

.pdfViewer.singlePageView{
  display:inline-block;
}

.pdfViewer.singlePageView .page{
  margin:0;
  border:none;
}

.pdfViewer:is(.scrollHorizontal, .scrollWrapped),
.spread{
  margin-inline:3.5px;
  text-align:center;
}

.pdfViewer.scrollHorizontal,
.spread{
  white-space:nowrap;
}

.pdfViewer.removePageBorders,
.pdfViewer:is(.scrollHorizontal, .scrollWrapped) .spread{
  margin-inline:0;
}

.spread :is(.page, .dummyPage),
.pdfViewer:is(.scrollHorizontal, .scrollWrapped) :is(.page, .spread){
  display:inline-block;
  vertical-align:middle;
}

.spread .page,
.pdfViewer:is(.scrollHorizontal, .scrollWrapped) .page{
  margin-inline:-3.5px;
  margin-inline:var(--spreadHorizontalWrapped-margin-LR);
}

.pdfViewer.removePageBorders .spread .page,
.pdfViewer.removePageBorders:is(.scrollHorizontal, .scrollWrapped) .page{
  margin-inline:5px;
}

.pdfViewer .page.loadingIcon::after{
  position:absolute;
  top:0;
  left:0;
  content:"";
  width:100%;
  height:100%;
  background:url(${___CSS_LOADER_URL_REPLACEMENT_9___}) center no-repeat;
  display:none;
  transition-property:display;
  transition-delay:400ms;
  transition-delay:var(--loading-icon-delay);
  z-index:5;
  contain:strict;
}

.pdfViewer .page.loading::after{
  display:block;
}

.pdfViewer .page:not(.loading)::after{
  transition-property:none;
  display:none;
}

.pdfPresentationMode .pdfViewer{
  padding-bottom:0;
}

.pdfPresentationMode .spread{
  margin:0;
}

.pdfPresentationMode .pdfViewer .page{
  margin:0 auto;
  border:2px solid transparent;
}
`, "",{"version":3,"sources":["webpack://./node_modules/pdfjs-dist/web/pdf_viewer.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;EAaE;;AAEF;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gDAAgD;EAChD,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,sDAAsD;;EAEtD,+BAA+B;EAC/B,yBAAyB;EACzB,+CAA+C;;EAE/C,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,oCAAoC;;EAEpC,mCAAmC;EACnC,qDAAqD;EACrD,gEAAgE;EAChE,kEAAkE;EAClE,kEAAkE;EAClE,4EAA4E;;EAE5E,iCAAiC;EACjC,iCAAiC;EACjC,8DAA8D;EAC9D,8DAA8D;EAC9D,wEAAwE;;EAExE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,2CAA2C;EAC3C,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,oCAAoC;IACpC,4BAA4B;IAC5B,8BAA8B;IAC9B,uBAAuB;IACvB,8BAA8B;;IAE9B,2BAA2B;;IAE3B,wBAAwB;IACxB,gCAAgC;IAChC,iCAAiC;;IAEjC,mCAAmC;IACnC,8BAA8B;IAC9B,iCAAiC;AACrC;EACE;;AAEF;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,oBAAoB;IACpB,+BAA+B;IAC/B,iCAAiC;IACjC,mBAAmB;IACnB,+BAA+B;;IAE/B,oCAAoC;IACpC,yBAAyB;IACzB,8BAA8B;;IAE9B,2BAA2B;IAC3B,mCAAmC;IACnC,+BAA+B;IAC/B,uCAAuC;;IAEvC,sCAAsC;IACtC,sCAAsC;IACtC,0CAA0C;IAC1C,6CAA6C;IAC7C,iDAAiD;;IAEjD,oCAAoC;IACpC,oCAAoC;IACpC,2CAA2C;IAC3C,+CAA+C;AACnD;EACE;;AAEF;MACM,iCAAiC;MACjC,kBAAkB;IACpB;;AAEJ;MACM,YAAY;MACZ,qBAAqB;MACrB,sBAAsB;MACtB,OAAO;IACT;;AAEJ;QACQ,YAAY;QACZ,OAAO;QACP,kBAAkB;QAClB,kBAAkB;MACpB;;AAEN;UACU,uBAAuB;kBAEf,eAAe;UACvB,qBAAqB;UACrB,UAAU;UACV,WAAW;UACX,iBAAiB;UACjB,sCAAsC;UACtC,0CAA0C;QAC5C;;AAER;YACY,0BAA0B;UAC5B;;AAEV;YACY,8CAA8C;YAC9C,kDAAkD;UACpD;;AAEV;QACQ,YAAY;QACZ,yBAAyB;QACzB,sBAAsB;QACtB,QAAQ;QACR,kBAAkB;MACpB;;AAEN;UACU,QAAU;UACV,cAAc;UACd,iCAAiC;QACnC;;AAER;MACM,iBAAiB;MACjB,gBAAgB;MAChB,SAAS;MACT,eAAe;MACf,gBAAgB;MAChB,UAAU;MACV,WAAW;IACb;;AAEJ;QACQ,cAAc;QACd,0BAA0B;MAC5B;;AAEN;QACQ,sCAAsC;QACtC,iDAAiD;QACjD,iDAAiD;MACnD;;AAEN;UACU,4CAA4C;UAC5C,uDAAuD;UACvD,uDAAuD;QACzD;;AAER;QACQ,0CAA0C;QAC1C,qDAAqD;QACrD,qDAAqD;QACrD,SAAS;MACX;;AAEN;UACU,0CAA0C;UAC1C,qDAAqD;UACrD,qDAAqD;QACvD;;AAER;MACM,YAAY;MACZ,WAAW;MACX,WAAW;MACX,QAAQ;MACR,qBAAqB;MACrB,iBAAiB;MACjB,6CAA6C;MAC7C,mCAAmC;MACnC,8BAA8B;IAChC;;AAEJ;QACQ,gBAAgB;QAChB,wBAAwB;MAC1B;;AAEN;QACQ,mBAAmB;QACnB,WAAW;MACb;;AAEN;EACE,iBAAiB;EACjB,eAAkB;EAAlB,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,SAAS;EACT,aAAa;EACb,6BAA6B;KAC1B,0BAA0B;UACrB,qBAAqB;EAC7B,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;AACX;;AAEA;IACI,iBAAiB;EACnB;;AAEF;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,sBAAsB;EACxB;;AAEF;;IAEI,SAAS;EACX;;AAEF;IACI,KAAK;IACL,QAAQ;EACV;;AAEF;IACI,0CAA0C;IAC1C,iDAAiD;IACjD,gCAAgC;IAChC,yCAAyC;;IAEzC,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,wDAAwD;YAChD,gDAAgD;IACxD,iBAAiB;EACnB;;AAEF;;AAEA;MACM,gCAAgC;MAChC,yCAAyC;MACzC,uDAAuD;MACvD;;OAEC;EACL;IACE;;AAEJ;MACM,eAAgB;MAAhB,gBAAgB;IAClB;;AAEJ;MACM,yBAAyB;IAC3B;;AAEJ;MACM,yBAAyB;IAC3B;;AAEJ;MACM,eAAe;IACjB;;AAEJ;MACM,mDAAmD;MACnD,iEAAiE;cACzD,yDAAyD;IACnE;;AAOJ;IACI,+BAA+B;IAC/B,2DAA2D;EAC7D;;AAMF;IACI,sBAAsB;EACxB;;AAEF;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,cAAc;IACd,wBAAwB;YAEhB,gBAAgB;EAC1B;;AAEF;MACM,KAAK;IACP;;AAEJ;EACE,8NAA8N;EAC9N,oCAAoC;EACpC,sCAAsC;EACtC,0CAA0C;EAC1C,yCAAyC;EACzC,gCAAgC;EAChC,mBAAmB;;EAEnB,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;AAEA;IACI,qCAAqC;IACrC,yCAAyC;IACzC,sCAAsC;IACtC,oCAAoC;IACpC,mCAAmC;AACvC;;IAEI;MACE,gCAAgC;IAClC;;IAEA;MACE,2BAA2B;IAC7B;;MAEE;QACE,mDAAmD;gBAC3C,2CAA2C;MACrD;;MAEA;QACE,oBAAoB;QACpB,0BAA0B;QAC1B,eAAe;MACjB;;IAEF;MACE,qEAAqE;MACrE,sCAAsC;MACtC,2BAA2B;IAC7B;;IAEA;MACE,iBAAiB;MACjB,KAAK;MACL,MAAM;MACN,UAAU;MACV,WAAW;MACX,mDAAmD;cAC3C,2CAA2C;MACnD,UAAU;MACV,mBAAmB;IACrB;;IAEA;MACE,kEAAkE;IACpE;EACF;;AAEF;IACI,0CAA0C;EAC5C;;AAEF;IACI,gDAAgD;EAClD;;AAEF;IACI,yCAAyC;EAC3C;;AAEF;;MAEM,mBAAmB;IACrB;;AAEJ;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,mBAAmB;EACrB;;AAEF;MACM,sBAAsB;MACtB,WAAW;MACX,OAAO;MACP,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,wBAAwB;cAEhB,gBAAgB;IAC1B;;AAEJ;IACI,iBAAiB;IACjB,eAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;EACtB;;AAEF;QACQ,YAAY;MACd;;AAEN;IACI,iBAAiB;IACjB,aAAa;IACb,KAAK;IACL,MAAM;IACN,UAAU;IACV,WAAW;EACb;;AAEF;;IAEI,WAAW;IACX,+BAA+B;IAC/B,oCAAoC;EACtC;;AAEF;IACI,qCAAqC;EACvC;;AAEF;IACI,yBAAyB;EAC3B;;AAEF;IACI,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,WAAW;IACX,KAAK;IACL,MAAM;EACR;;AAEF;IACI,6DAA6D;IAC7D,oDAAoD;IACpD,qBAAqB;IACrB,+CAA+C;IAC/C,WAAW;IACX,QAAQ;IACR,kBAAkB;IAClB,UAAU;EACZ;;AAEF;IACI,uBAAuB;EACzB;;AAEF;IACI,SAAS;EACX;;AAEF;IACI,iBAAiB;EACnB;;AAEF;IACI,WAAW;EACb;;AAEF;IACI,eAAe;IACf,mDAAmD;IACnD,kBAAkB;EACpB;;AAEF;IACI,gDAAgD;EAClD;;AAEF;IACI,iBAAiB;EACnB;;AAEF;IACI,eAAe;IACf,gDAAgD;IAChD,iBAAiB;IACjB,kCAAkC;EACpC;;AAEF;IACI,qBAAqB;IACrB,4BAA4B;EAC9B;;AAEF;IACI,gDAAgD;IAChD,iBAAiB;IACjB,kCAAkC;EACpC;;AAEF;IACI,gDAAgD;IAChD,kCAAkC;EACpC;;AAEF;;;IAGI,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,iBAAiB;EACnB;;AAEF;;IAEI,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;AAEF;IACI,uBAAuB;EACzB;;AAEF;IACI,wBAAwB;EAC1B;;AAEF;IACI,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,OAAO;IACP,SAAS;EACX;;AAEF;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;EACjB;;AAEF;IACI,UAAU;EACZ;;AAEF;IACI,uBAAuB;YAEf,eAAe;EACzB;;AAEF;IACI,WAAW;IACX,UAAU;EACZ;;AAEF;IACI,iBAAiB;IACjB,yCAAyC;IACzC,mBAAmB;IAEnB,yBAAiB;IAAjB,iBAAiB;IACjB,aAAa;IACb,WAAW;EACb;;AAEF;IACI,iCAAiC;IACjC,6FAA6F;IAC7F,6CAA6C;IAC7C,mCAAmC;IACnC,uCAAuC;IACvC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;EACrB;;AAEF;IACI,iBAAiB;EACnB;;AAEF;IACI,yCAAyC;EAC3C;;AAEF;IACI,oBAAoB;EACtB;;AAEF;IACI,cAAc;EAChB;;AAEF;IACI,oBAAoB;IACpB,2CAA2C;IAC3C,sBAAsB;IACtB,yBAAiB;IAAjB,iBAAiB;EACnB;;AAEF;IACI,kCAAkC;IAClC,0CAA0C;IAC1C,2CAA2C;EAC7C;;AAEF;IACI,oBAAoB;IACpB,yCAAyC;EAC3C;;AAEF;IACI,cAAc;EAChB;;AAEF;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,KAAK;IACL,MAAM;EACR;;AAEF;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,wBAAwB;YAEhB,gBAAgB;IACxB,mBAAmB;EACrB;;AAEF;MACM,UAAU;MACV,oBAAoB;IACtB;;AAEJ;IACI,cAAc;IACd,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,UAAU;EACZ;;AAEF;EACE,uNAAuN;EACvN,wBAAwB;AAC1B;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,eAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAkB;EAAlB,kBAAkB;EAClB,KAAK;EACL,MAAM;EACN,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6BAAoB;EAApB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAiB;EAAjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,YAAgC;EAAhC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAgC;EAAhC,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,aAAa;EACb,WAAW;EACX,WAAW;EACX,uMAAsD;EAAtD,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,KAAK;EACL,MAAM;AACR;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,WAAW;AACb;;AAEA;EAEK,wBAAwB;EAExB,kBAAkB;EACrB,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,QAAM;AACR;;AAEA;EACE,QAAM;AACR;;AAEA;EACE,gFAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;YAEf,eAAe;IACvB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;IACI,cAAc;EAChB;;AAEF;;QAEQ,mCAAmC;MACrC;;AAEN;;QAEQ,oCAAoC;MACtC;;AAEN;;QAEQ,mCAAmC;MACrC;;AAEN;MACM,qBAAqB;;MAErB,iBAAiB;MACjB,gCAAgC;IAClC;;AAEJ;;AAEA;QACQ,uBAAuB;IAC3B;MACE;;AAEN;QACQ,iBAAiB;MACnB;;AAEN;MACM,iBAAiB;MACjB,qBAAqB;MACrB,iBAAiB;MACjB,SAAS;IACX;;AAEJ;UACU,cAAiC;UAAjC,iCAAiC;UACjC,gBAAiC;UAAjC,iCAAiC;QACnC;;AAER;YACY,cAAkC;YAAlC,kCAAkC;YAClC;;aAEC;YAFD;;aAEC;UACH;;AAEV;YACY,cAA2B;YAA3B,2BAA2B;YAC3B,gBAAiC;YAAjC,iCAAiC;UACnC;;AAEV;UACU,cAAiC;UAAjC,iCAAiC;UACjC,0BAA2C;UAA3C,2CAA2C;QAC7C;;AAER;YACY,cAAkC;YAAlC,kCAAkC;YAClC;;aAEC;YAFD;;aAEC;UACH;;AAEV;YACY,cAA2B;YAA3B,2BAA2B;YAC3B,0BAA2C;YAA3C,2CAA2C;UAC7C;;AAEV;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wCAAwC;EACxC,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;;EAEpB,wDAAwD;EACxD,oEAAoE;EACpE,sEAAsE;EACtE,6DAA6D;EAC7D,yEAAyE;EACzE,2EAA2E;EAC3E,qDAAqD;EACrD,sDAAsD;EACtD,uDAAuD;EACvD,kDAAkD;EAClD,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,wDAAwD;EACxD,sEAAsE;EACtE,uEAAuE;EACvE,4DAA4D;EAC5D,uBAAuB;EACvB;;;GAGC;EACD,2CAA2C;EAC3C;;GAEC;;EAED,uBAAuB;;UAIf,eAAe;EACvB,SAAS;EACT,QAAQ;EACR,kEAAkE;EAClE,2BAA2B;EAC3B,yBAAyB;EACzB,yCAAyC;EACzC,yCAAyC;EACzC,qBAAqB;EACrB,aAAa;AACf;;AAEA;;AAEA;IACI,0EAA0E;IAC1E;;;;KAIC;IACD;;;;KAIC;IACD,2BAA2B;IAC3B,oCAAoC;IACpC,qCAAqC;IACrC,kCAAkC;IAClC,sBAAsB;AAC1B;EACE;;AAEF;;AAEA;IACI,iCAAiC;IACjC,yCAAyC;IACzC,0CAA0C;IAC1C,qCAAqC;IACrC,oCAAoC;IACpC,6CAA6C;IAC7C,8CAA8C;IAC9C,4CAA4C;IAC5C,yBAAyB;AAC7B;EACE;;AAEF;IACI,yBAA4B;IAA5B,4BAA4B;IAC5B,0CAA0C;EAC5C;;AAEF;IACI,+CAA+C;IAC/C,uCAAuC;EACzC;;AAEF;IACI,gDAAgD;IAChD,uCAAuC;EACzC;;AAEF;IACI,iDAAiD;IACjD,wBAAwB;EAC1B;;AAEF;IACI,uDAAuD;IACvD,wBAAwB;EAC1B;;AAEF;IACI,wDAAwD;IACxD,wBAAwB;EAC1B;;AAEF;IACI,aAAa;IACb,UAAU;IACV,mDAAmD;IACnD,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,yCAAyC;IACzC,WAAW;EACb;;AAEF;IACI,uCAAuC;IACvC,8DAA8D;EAChE;;AAEF;;IAEI,8DAA8D;EAChE;;AAEF;IACI,kDAAkD;EACpD;;AAEF;IACI;MACE,0BAA0B;IAC5B;EACF;;AAEF;IACI;MACE,6CAA6C;IAC/C;;IAEA;MACE,8CAA8C;IAChD;;IAEA;MACE,uCAAuC;MACvC,iBAAiB;IACnB;;IAEA;;MAEE,6CAA6C;IAC/C;;IAEA;MACE,0DAA0D;MAC1D,qDAAqD;IACvD;;IAEA;;MAEE,yDAAyD;IAC3D;EACF;;AAEF;;AAEA;IACI,yDAAyD;IACzD,qEAAqE;IACrE,uEAAuE;IACvE,uEAAuE;IACvE,0EAA0E;IAC1E,iEAAiE;IACjE,mEAAmE;IACnE,uEAAuE;AAC3E;;IAEI;MACE,+CAA+C;MAC/C,UAAU;MACV,iBAAiB;MACjB,2BAA2B;MAC3B,yBAAyB;MACzB,aAAa;MACb,yCAAyC;MACzC,UAAU;IACZ;;IAEA;MACE,8CAA8C;IAChD;EACF;;AAEF;EACE,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;EAC9B,wDAAwD;EACxD,+DAA+D;EAC/D,wDAAwD;EACxD,oFAAoF;EACpF,6BAA6B;EAC7B,qEAAqE;EACrE,0FAA0F;EAC1F,2BAA2B;EAC3B,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;EAClB;;;GAGC;EACD,oCAAoC;EACpC,gFAAyE;EACzE,oFAAuF;EACvF,0FAA6F;AAC/F;AACA;EACE,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4DAAgD;EAAhD,gDAAgD;AAClD;;AAEA;IACI,0DAA4C;IAA5C,4CAA4C;EAC9C;;AAEF;IACI,4DAAgD;IAAhD,gDAAgD;EAClD;;AAEF;EACE;IACE,kFAAgF;EAClF;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,iCAAiC;IACjC,6BAA6B;IAC7B,+BAA+B;IAC/B,6CAA6C;EAC/C;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,OAAO;EACP,2CAA2C;EAC3C,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,OAAO;EACP,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,4DAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,eAAe;EACf,4BAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;IACI,WAAW;EACb;;AAEF;IACI,iBAAiB;EACnB;;AAEF;IACI,wBAA2B;IAA3B,2BAA2B;IAC3B,yBAAmC;IAAnC,mCAAmC;EACrC;;AAEF;MACM,UAAU;MACV,iBAAiB;MACjB,OAAO;MACP,wBAAkC;MAAlC,kCAAkC;MAClC,mBAAmB;IACrB;;AAEJ;IACI,wBAA2B;IAA3B,2BAA2B;IAC3B,yBAAmC;IAAnC,mCAAmC;EACrC;;AAEF;MACM,UAAU;MACV,iBAAiB;MACjB,OAAO;MACP,wBAAkC;MAAlC,kCAAkC;IACpC;;AAEJ;;IAEI,qEAAmE;IACnE,iCAAiC;IACjC,wEAA8E;IAC9E,iCAAiC;IACjC,qCAAqC;IACrC,sEAAsE;IACtE,uCAAuC;IACvC,8DAA8D;IAC9D,mCAAmC;IACnC,4CAA4C;IAC5C,uDAAuD;IACvD,gCAAgC;IAChC,4BAA4B;IAC5B,4BAA4B;;IAE5B,YAAY;IACZ,sBAAsB;IACtB,yBAAiB;IAAjB,iBAAiB;IACjB,mCAAmC;IACnC,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,qCAAqC;;IAErC,iBAAiB;IACjB,kBAAkB;IAClB,gEAAgE;;IAEhE,iBAAiB;IACjB,+CAA+C;IAC/C,mDAAmD;IACnD,uCAAuC;EACzC;;AAEF;;AAEA;;MAEM,iCAAiC;MACjC,iCAAiC;MACjC,uCAAuC;MACvC,yCAAyC;EAC7C;IACE;;AAEJ;;AAEA;;MAEM,oCAAoC;MACpC,oCAAoC;MACpC,wCAAwC;MACxC,+CAA+C;MAC/C,0CAA0C;MAC1C,2CAA2C;MAC3C,iFAAiF;MACjF,iDAAiD;MACjD,4BAA4B;EAChC;IACE;;AAEJ;;MAEM,YAAY;IACd;;AAEJ;;MAEM,wBAAwB;IAC1B;;AAEJ;;MAEM,uBAAuB;IACzB;;AAEJ;;MAEM,oBAAoB;IACtB;;AAEJ;;MAEM,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,KAAK;MACL,WAAW;IACb;;AAEJ;;QAEQ,SAAS;QACT;;SAEC;QACD,mDAAmD;QACnD,oBAAoB;QACpB,iBAAiB;MACnB;;AAEN;;QAEQ,kCAAkC;MACpC;;AAEN;;UAEU,UAAU;UACV,wDAAwD;kBAChD,gDAAgD;UACxD,6BAA6B;kBACrB,qBAAqB;UAC7B,4BAA4B;kBACpB,oBAAoB;UAC5B,oBAAoB;UACpB,+CAA+C;UAC/C,UAAU;UACV,WAAW;QACb;;AAER;;UAEU,qDAAqD;QACvD;;AAER;;QAEQ,kCAAkC;MACpC;;AAEN;;UAEU,UAAU;UACV,qDAAqD;kBAC7C,6CAA6C;UACrD,6BAA6B;kBACrB,qBAAqB;UAC7B,4BAA4B;kBACpB,oBAAoB;UAC5B,oBAAoB;UACpB,+CAA+C;UAC/C,UAAU;UACV,WAAW;QACb;;AAER;;UAEU,qDAAqD;QACvD;;AAER;;QAEQ,mCAAmC;MACrC;;AAEN;;QAEQ,WAAW;QACX,4BAA4B;QAC5B,cAAc;MAChB;;AAEN;;UAEU,iBAAiB;UACjB,qDAAqD;UACrD,0CAA0C;UAC1C,2CAA2C;UAC3C,kBAAkB;QACpB;;AAER;;YAEY,YAAY;UACd;;AAEV;;UAEU,iBAAiB;UACjB,2DAA2D;QAC7D;;AAER;;QAEQ,4DAAgD;QAChD,6DAAkD;;QAElD,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;QAEtB,yBAAiB;QAAjB,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,cAAc;QACd,oCAAoC;MACtC;;AAEN;;UAEU,mBAAmB;QACrB;;AAER;;UAEU,UAAU;UACV,4CAA4C;kBACpC,oCAAoC;UAC5C,6BAA6B;kBACrB,qBAAqB;UAC7B,4BAA4B;kBACpB,oBAAoB;UAC5B,oBAAoB;UACpB,UAAU;UACV,WAAW;UACX,+CAA+C;UAC/C,qBAAqB;QACvB;;AAER;;UAEU,qDAAqD;QACvD;;AAER;;UAEU,6CAA6C;kBACrC,qCAAqC;QAC/C;;AAER;;UAEU,YAAY;QACd;;AAER;;YAEY,6BAA6B;YAC7B,6BAA6B;YAC7B,iCAAiC;YACjC,6DAA6D;;YAE7D,mBAAmB;YACnB,qBAAqB;YACrB,kBAAkB;YAClB,sBAAsB;YACtB,iBAAiB;YACjB,oBAAoB;YACpB,oBAAoB;YACpB,qBAAqB;YACrB,kBAAkB;YAClB,eAAe;YAEf,yBAAiB;YAAjB,iBAAiB;YACjB,WAAW;YACX,cAAc;;YAEd,iDAAiD;YACjD,qCAAqC;YACrC,yCAAyC;YACzC,gCAAgC;;YAEhC,mBAAmB;UACrB;;AAEV;;AAEA;;cAEc,6BAA6B;cAC7B,6BAA6B;cAC7B,iDAAiD;UACrD;YACE;;AAEZ;;AAEA;;cAEc,4BAA4B;cAC5B,gCAAgC;cAChC,oCAAoC;cACpC,8BAA8B;UAClC;YACE;;AAEZ;EACE,uCAA2D;EAA3D,2DAA2D;EAC3D,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAuC;EAAvC,uCAAuC;EACvC,wBAAwB;UAEhB,gBAAgB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,OAAO;EACP,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,wBAAwB;UAEhB,gBAAgB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,QAAQ;EACV;;AAEF;MACM,iBAAiB;MACjB,OAAO;IACT;;AAEJ;QACQ,YAAY;MACd;;AAEN;QACQ,SAAyB;QAAzB,yBAAyB;QACzB,UAA0B;QAA1B,0BAA0B;QAC1B,8BAA8C;QAA9C,8CAA8C;QAC9C,wBAAkC;QAAlC,kCAAkC;QAClC,iBAAiB;QACjB,iBAAiB;MACnB;;AAEN;UACU;;;GAAwB;UAAxB,wBAAwB;UACxB;;;GAAyB;UAAzB,yBAAyB;QAC3B;;AAER;UACU;;;GAAwB;UAAxB,wBAAwB;UACxB;;;IAAqC;UAArC,qCAAqC;QACvC;;AAER;UACU;;;GAAwB;UAAxB,wBAAwB;UACxB;;;GAA0B;UAA1B,0BAA0B;QAC5B;;AAER;UACU;;;IAAoC;UAApC,oCAAoC;UACpC;;;GAA0B;UAA1B,0BAA0B;QAC5B;;AAER;UACU;;;GAA2B;UAA3B,2BAA2B;UAC3B;;;GAA0B;UAA1B,0BAA0B;QAC5B;;AAER;UACU;;;GAA2B;UAA3B,2BAA2B;UAC3B;;;IAAqC;UAArC,qCAAqC;QACvC;;AAER;UACU;;;GAA2B;UAA3B,2BAA2B;UAC3B;;;GAAyB;UAAzB,yBAAyB;QAC3B;;AAER;UACU;;;IAAoC;UAApC,oCAAoC;UACpC;;;GAAyB;UAAzB,yBAAyB;QAC3B;;AAER;;;;;;;;;;;;;;;;QAgBQ,kBAAkB;MACpB;;AAEN;;;;;;;;;;;;;;;;QAgBQ,gBAAgB;MAClB;;AAEN;;;;;;;;;;;;;;;;QAgBQ,kBAAkB;MACpB;;AAEN;;;;;;;;;;;;;;;;QAgBQ,gBAAgB;MAClB;;AAEN;;;;;;;;;;;;;;;;QAgBQ,kBAAkB;MACpB;;AAEN;;;;;;;;;;;;;;;;QAgBQ,gBAAgB;MAClB;;AAEN;;;;;;;;;;;;;;;;QAgBQ,kBAAkB;MACpB;;AAEN;;;;;;;;;;;;;;;;QAgBQ,gBAAgB;MAClB;;AAEN;;;;;;;MAOM,aAAa;IACf;;AAEJ;;;;;;;QAOQ,8DAA8D;QAC9D,mBAAmB;MACrB;;AAEN;;;;;;;QAOQ,+DAA+D;QAC/D,mBAAmB;MACrB;;AAEN;;;;;;;MAOM,aAAa;MACb,qBAAqB;MACrB,+DAA+D;IACjE;;AAEJ;;;;;;;MAOM,YAAY;IACd;;AAEJ;;;;;;;QAOQ,+DAA+D;QAC/D,sBAAsB;MACxB;;AAEN;;;;;;;QAOQ,gEAAgE;QAChE,mBAAmB;MACrB;;AAEN;IACI,uCAAuC;YAC/B,+BAA+B;EACzC;;AAEF;IACI,QAAQ;EACV;;AAEF;IACI,WAAW;IACX,uBAAuB;IACvB,0BAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,QAAQ;EACV;;AAEF;MACM,YAAY;MACZ,qBAAqB;MACrB,sBAAsB;MACtB,OAAO;MACP,kBAAkB;IACpB;;AAEJ;QACQ,kBAAkB;MACpB;;AAEN;QACQ,cAAc;QACd,iBAAiB;QACjB,eAAe;MACjB;;AAEN;MACM,YAAY;MACZ,qBAAqB;MACrB,mBAAmB;MACnB,OAAO;IACT;;AAEJ;QACQ,QAAM;QACN,wBAAwB;MAC1B;;AAEN;UACU,UAAU;UACV,eAAe;QACjB;;AAER;MACM,YAAY;MACZ,wBAAwB;MACxB,sBAAsB;MACtB,OAAO;MACP,kBAAkB;IACpB;;AAEJ;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,6BAA6B;AACjC;EACE;;AAEF;;AAEA;IACI,+BAA+B;IAC/B,mDAAmD;IACnD,gCAAgC;AACpC;EACE;;AAEF;IACI,UAAU;IACV,WAAW;IACX,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;EAC1B;;AAEF;IACI,WAAW;EACb;;AAEF;MACM,WAAW;IACb;;AAEJ;MACM,aAAa;IACf;;AAEJ;MACM,aAAa;IACf;;AAEJ;MACM,YAAY;IACd;;AAEJ;IACI,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;EACtB;;AAEF;MACM,cAAc;IAChB;;AAEJ;MACM,iBAAiB;MACjB,KAAK;MACL,MAAM;MACN,UAAU;MACV,WAAW;MACX,mBAAmB;IACrB;;AAEJ;MACM,mBAAmB;IACrB;;AAEJ;QACQ,cAAc;MAChB;;AAEN;MACM,gFAAgF;;MAEhF,kCAAkC;IACpC;;AAEJ;UACU,iBAAiB;UACjB,UAAU;UACV,YAAY;UACZ,sBAAsB;UACtB,kBAAkB;UAClB,OAAO;UACP,WAAW;QACb;;AAER;YACY,UAAU;YACV,gEAAgE;oBACxD,wDAAwD;YAChE,6BAA6B;oBACrB,qBAAqB;YAC7B,4BAA4B;oBACpB,oBAAoB;YAC5B,oBAAoB;YACpB,+CAA+C;YAC/C,UAAU;YACV,WAAW;UACb;;AAEV;YACY,qDAAqD;UACvD;;AAEV;YACY,qDAAqD;UACvD;;AAEV;cACc,QAAQ;YACV;;AAEZ;YACY,iBAAiB;YACjB,YAAY;YACZ,sBAAsB;YACtB,kBAAkB;YAClB,qBAAqB;YACrB,QAAQ;YACR,iBAAiB;YACjB,iBAAiB;YACjB,+CAA+C;YAC/C,mDAAmD;YACnD,uCAAuC;YACvC,kCAAkC;YAClC,oDAAoD;UACtD;;AAEV;cACc,UAAU;cACV,WAAW;cACX,WAAW;cACX,cAAc;cACd,YAAY;cACZ,sBAAsB;cACtB,kBAAkB;cAClB,eAAe;YACjB;;AAEZ;gBACgB,YAAY;cACd;;AAEd;gBACgB,kBAAkB;cACpB;;AAEd;gBACgB,+CAA+C;cACjD;;AAEd;gBACgB,yBAA4C;gBAA5C,4CAA4C;cAC9C;;AAEd;EACE,SAAa;EAAb,eAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAiB;IAAjB,iBAAiB;IACjB,oBAAoB;EACtB;;AAEF;IACI,YAAY;IACZ,qBAAqB;IACrB,OAAO;EACT;;AAEF;MACM,YAAY;MACZ,6BAA6B;MAC7B,kBAAkB;MAClB,kBAAkB;MAClB,WAAW;IACb;;AAEJ;QACQ,UAAU;QACV,WAAW;QACX,WAAW;QACX,cAAc;QACd,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;QACf,aAAa;MACf;;AAEN;UACU,UAAU;UACV,WAAW;QACb;;AAER;UACU,YAAY;QACd;;AAER;UACU,+CAA+C;QACjD;;AAER;UACU,yBAA4C;UAA5C,4CAA4C;QAC9C;;AAER;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;IACP,kBAAkB;EACpB;;AAEF;MACM,UAAU;MACV,WAAW;MACX,kBAAkB;IACpB;;AAEJ;MACM,YAAY;MACZ,6BAA6B;MAC7B,kBAAkB;MAClB,kBAAkB;;MAElB,uBAAuB;IACzB;;AAEJ;;AAEA;QACQ,uBAAuB;IAC3B;MACE;;AAEN;;AAEA;QACQ,0BAA0B;IAC9B;MACE;;AAEN;QACQ,WAAW;MACb;;AAEN;;QAEQ,UAAU;QACV,SAAS;QACT,cAAc;QACd,aAAa;QACb,kBAAkB;QAClB,qCAAqC;MACvC;;AAEN;QACQ,UAAU;MACZ;;AAEN;QACQ,UAAW;QAAX,aAAW;QACX,WAAW;MACb;;AAEN;IACI,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,OAAO;IACP,kBAAkB;EACpB;;AAEF;MACM,uBAAuB;;MAEvB,gBAAgB;MAChB,UAAU;MACV,UAAU;MACV,qCAAqC;IACvC;;AAEJ;;AAEA;QACQ,uBAAuB;IAC3B;MACE;;AAEN;;AAEA;QACQ,0BAA0B;IAC9B;MACE;;AAEN;MACM,YAAY;MACZ,6BAA6B;MAC7B,kBAAkB;MAClB,kBAAkB;IACpB;;AAEJ;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;IAClC,yCAAyC;EAC3C;AACF;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;;EAEhB,gBAA8C;;EAA9C,8CAA8C;;EAE9C,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;AAEA;IACI,mCAAmC;AACvC;EACE;;AAEF;IACI,eAAe;IACf,UAAU;IACV,WAAW;EACb;;AAEF;MACM,QAAQ;MACR,aAAa;IACf;;AAEJ;QACQ,YAAY;MACd;;AAEN;QACQ,UAAU;QACV,WAAW;MACb;;AAEN;QACQ,cAAc;MAChB;;AAEN;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,oBAAyB;EAAzB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,4BAAyB;EAAzB,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,QAAqC;EAArC,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;UAEhB,gBAAgB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAsD;EAAtD,sDAAsD;AACxD;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,UAAU;EACV,UAAU;EACV,WAAW;EACX,mEAA0D;EAC1D,YAAY;EACZ,2BAA2B;EAC3B,sBAA0C;EAA1C,0CAA0C;EAC1C,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B","sourcesContent":["/* Copyright 2014 Mozilla Foundation\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.dialog{\n  --dialog-bg-color:white;\n  --dialog-border-color:white;\n  --dialog-shadow:0 2px 14px 0 rgb(58 57 68 / 0.2);\n  --text-primary-color:#15141a;\n  --text-secondary-color:#5b5b66;\n  --hover-filter:brightness(0.9);\n  --focus-ring-color:#0060df;\n  --focus-ring-outline:2px solid var(--focus-ring-color);\n\n  --textarea-border-color:#8f8f9d;\n  --textarea-bg-color:white;\n  --textarea-fg-color:var(--text-secondary-color);\n\n  --radio-bg-color:#f0f0f4;\n  --radio-checked-bg-color:#fbfbfe;\n  --radio-border-color:#8f8f9d;\n  --radio-checked-border-color:#0060df;\n\n  --button-secondary-bg-color:#f0f0f4;\n  --button-secondary-fg-color:var(--text-primary-color);\n  --button-secondary-border-color:var(--button-secondary-bg-color);\n  --button-secondary-hover-bg-color:var(--button-secondary-bg-color);\n  --button-secondary-hover-fg-color:var(--button-secondary-fg-color);\n  --button-secondary-hover-border-color:var(--button-secondary-hover-bg-color);\n\n  --button-primary-bg-color:#0060df;\n  --button-primary-fg-color:#fbfbfe;\n  --button-primary-hover-bg-color:var(--button-primary-bg-color);\n  --button-primary-hover-fg-color:var(--button-primary-fg-color);\n  --button-primary-hover-border-color:var(--button-primary-hover-bg-color);\n\n  font:message-box;\n  font-size:13px;\n  font-weight:400;\n  line-height:150%;\n  border-radius:4px;\n  padding:12px 16px;\n  border:1px solid var(--dialog-border-color);\n  background:var(--dialog-bg-color);\n  color:var(--text-primary-color);\n  box-shadow:var(--dialog-shadow);\n}\n\n@media (prefers-color-scheme: dark){\n\n.dialog{\n    --dialog-bg-color:#1c1b22;\n    --dialog-border-color:#1c1b22;\n    --dialog-shadow:0 2px 14px 0 #15141a;\n    --text-primary-color:#fbfbfe;\n    --text-secondary-color:#cfcfd8;\n    --focus-ring-color:#0df;\n    --hover-filter:brightness(1.4);\n\n    --textarea-bg-color:#42414d;\n\n    --radio-bg-color:#2b2a33;\n    --radio-checked-bg-color:#15141a;\n    --radio-checked-border-color:#0df;\n\n    --button-secondary-bg-color:#2b2a33;\n    --button-primary-bg-color:#0df;\n    --button-primary-fg-color:#15141a;\n}\n  }\n\n@media screen and (forced-colors: active){\n\n.dialog{\n    --dialog-bg-color:Canvas;\n    --dialog-border-color:CanvasText;\n    --dialog-shadow:none;\n    --text-primary-color:CanvasText;\n    --text-secondary-color:CanvasText;\n    --hover-filter:none;\n    --focus-ring-color:ButtonBorder;\n\n    --textarea-border-color:ButtonBorder;\n    --textarea-bg-color:Field;\n    --textarea-fg-color:ButtonText;\n\n    --radio-bg-color:ButtonFace;\n    --radio-checked-bg-color:ButtonFace;\n    --radio-border-color:ButtonText;\n    --radio-checked-border-color:ButtonText;\n\n    --button-secondary-bg-color:ButtonFace;\n    --button-secondary-fg-color:ButtonText;\n    --button-secondary-border-color:ButtonText;\n    --button-secondary-hover-bg-color:AccentColor;\n    --button-secondary-hover-fg-color:AccentColorText;\n\n    --button-primary-bg-color:ButtonText;\n    --button-primary-fg-color:ButtonFace;\n    --button-primary-hover-bg-color:AccentColor;\n    --button-primary-hover-fg-color:AccentColorText;\n}\n  }\n\n.dialog .mainContainer *:focus-visible{\n      outline:var(--focus-ring-outline);\n      outline-offset:2px;\n    }\n\n.dialog .mainContainer .radio{\n      display:flex;\n      flex-direction:column;\n      align-items:flex-start;\n      gap:4px;\n    }\n\n.dialog .mainContainer .radio > .radioButton{\n        display:flex;\n        gap:8px;\n        align-self:stretch;\n        align-items:center;\n      }\n\n.dialog .mainContainer .radio > .radioButton input{\n          -webkit-appearance:none;\n             -moz-appearance:none;\n                  appearance:none;\n          box-sizing:border-box;\n          width:16px;\n          height:16px;\n          border-radius:50%;\n          background-color:var(--radio-bg-color);\n          border:1px solid var(--radio-border-color);\n        }\n\n.dialog .mainContainer .radio > .radioButton input:hover{\n            filter:var(--hover-filter);\n          }\n\n.dialog .mainContainer .radio > .radioButton input:checked{\n            background-color:var(--radio-checked-bg-color);\n            border:4px solid var(--radio-checked-border-color);\n          }\n\n.dialog .mainContainer .radio > .radioLabel{\n        display:flex;\n        padding-inline-start:24px;\n        align-items:flex-start;\n        gap:10px;\n        align-self:stretch;\n      }\n\n.dialog .mainContainer .radio > .radioLabel > span{\n          flex:1 0 0;\n          font-size:11px;\n          color:var(--text-secondary-color);\n        }\n\n.dialog .mainContainer button{\n      border-radius:4px;\n      border:1px solid;\n      font:menu;\n      font-weight:600;\n      padding:4px 16px;\n      width:auto;\n      height:32px;\n    }\n\n.dialog .mainContainer button:hover{\n        cursor:pointer;\n        filter:var(--hover-filter);\n      }\n\n.dialog .mainContainer button.secondaryButton{\n        color:var(--button-secondary-fg-color);\n        background-color:var(--button-secondary-bg-color);\n        border-color:var(--button-secondary-border-color);\n      }\n\n.dialog .mainContainer button.secondaryButton:hover{\n          color:var(--button-secondary-hover-fg-color);\n          background-color:var(--button-secondary-hover-bg-color);\n          border-color:var(--button-secondary-hover-border-color);\n        }\n\n.dialog .mainContainer button.primaryButton{\n        color:var(--button-primary-hover-fg-color);\n        background-color:var(--button-primary-hover-bg-color);\n        border-color:var(--button-primary-hover-border-color);\n        opacity:1;\n      }\n\n.dialog .mainContainer button.primaryButton:hover{\n          color:var(--button-primary-hover-fg-color);\n          background-color:var(--button-primary-hover-bg-color);\n          border-color:var(--button-primary-hover-border-color);\n        }\n\n.dialog .mainContainer textarea{\n      font:inherit;\n      padding:8px;\n      resize:none;\n      margin:0;\n      box-sizing:border-box;\n      border-radius:4px;\n      border:1px solid var(--textarea-border-color);\n      background:var(--textarea-bg-color);\n      color:var(--textarea-fg-color);\n    }\n\n.dialog .mainContainer textarea:focus{\n        outline-offset:0;\n        border-color:transparent;\n      }\n\n.dialog .mainContainer textarea:disabled{\n        pointer-events:none;\n        opacity:0.4;\n      }\n\n.textLayer{\n  position:absolute;\n  text-align:initial;\n  inset:0;\n  overflow:clip;\n  opacity:1;\n  line-height:1;\n  -webkit-text-size-adjust:none;\n     -moz-text-size-adjust:none;\n          text-size-adjust:none;\n  forced-color-adjust:none;\n  transform-origin:0 0;\n  caret-color:CanvasText;\n  z-index:0;\n}\n\n.textLayer.highlighting{\n    touch-action:none;\n  }\n\n.textLayer :is(span, br){\n    color:transparent;\n    position:absolute;\n    white-space:pre;\n    cursor:text;\n    transform-origin:0% 0%;\n  }\n\n.textLayer > :not(.markedContent),\n  .textLayer .markedContent span:not(.markedContent){\n    z-index:1;\n  }\n\n.textLayer span.markedContent{\n    top:0;\n    height:0;\n  }\n\n.textLayer .highlight{\n    --highlight-bg-color:rgb(180 0 170 / 0.25);\n    --highlight-selected-bg-color:rgb(0 100 0 / 0.25);\n    --highlight-backdrop-filter:none;\n    --highlight-selected-backdrop-filter:none;\n\n    margin:-1px;\n    padding:1px;\n    background-color:var(--highlight-bg-color);\n    -webkit-backdrop-filter:var(--highlight-backdrop-filter);\n            backdrop-filter:var(--highlight-backdrop-filter);\n    border-radius:4px;\n  }\n\n@media screen and (forced-colors: active){\n\n.textLayer .highlight{\n      --highlight-bg-color:transparent;\n      --highlight-selected-bg-color:transparent;\n      --highlight-backdrop-filter:var(--hcm-highlight-filter);\n      --highlight-selected-backdrop-filter:var(\n        --hcm-highlight-selected-filter\n      );\n  }\n    }\n\n.textLayer .highlight.appended{\n      position:initial;\n    }\n\n.textLayer .highlight.begin{\n      border-radius:4px 0 0 4px;\n    }\n\n.textLayer .highlight.end{\n      border-radius:0 4px 4px 0;\n    }\n\n.textLayer .highlight.middle{\n      border-radius:0;\n    }\n\n.textLayer .highlight.selected{\n      background-color:var(--highlight-selected-bg-color);\n      -webkit-backdrop-filter:var(--highlight-selected-backdrop-filter);\n              backdrop-filter:var(--highlight-selected-backdrop-filter);\n    }\n\n.textLayer ::-moz-selection{\n    background:rgba(0 0 255 / 0.25);\n    background:color-mix(in srgb, AccentColor, transparent 75%);\n  }\n\n.textLayer ::selection{\n    background:rgba(0 0 255 / 0.25);\n    background:color-mix(in srgb, AccentColor, transparent 75%);\n  }\n\n.textLayer br::-moz-selection{\n    background:transparent;\n  }\n\n.textLayer br::selection{\n    background:transparent;\n  }\n\n.textLayer .endOfContent{\n    display:block;\n    position:absolute;\n    inset:100% 0 0;\n    z-index:0;\n    cursor:default;\n    -webkit-user-select:none;\n       -moz-user-select:none;\n            user-select:none;\n  }\n\n.textLayer .endOfContent.active{\n      top:0;\n    }\n\n.annotationLayer{\n  --annotation-unfocused-field-background:url(\"data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>\");\n  --input-focus-border-color:Highlight;\n  --input-focus-outline:1px solid Canvas;\n  --input-unfocused-border-color:transparent;\n  --input-disabled-border-color:transparent;\n  --input-hover-border-color:black;\n  --link-outline:none;\n\n  position:absolute;\n  top:0;\n  left:0;\n  pointer-events:none;\n  transform-origin:0 0;\n}\n\n@media screen and (forced-colors: active){\n\n.annotationLayer{\n    --input-focus-border-color:CanvasText;\n    --input-unfocused-border-color:ActiveText;\n    --input-disabled-border-color:GrayText;\n    --input-hover-border-color:Highlight;\n    --link-outline:1.5px solid LinkText;\n}\n\n    .annotationLayer .textWidgetAnnotation :is(input, textarea):required, .annotationLayer .choiceWidgetAnnotation select:required, .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input:required{\n      outline:1.5px solid selectedItem;\n    }\n\n    .annotationLayer .linkAnnotation{\n      outline:var(--link-outline);\n    }\n\n      .annotationLayer .linkAnnotation:hover{\n        -webkit-backdrop-filter:var(--hcm-highlight-filter);\n                backdrop-filter:var(--hcm-highlight-filter);\n      }\n\n      .annotationLayer .linkAnnotation > a:hover{\n        opacity:0 !important;\n        background:none !important;\n        box-shadow:none;\n      }\n\n    .annotationLayer .popupAnnotation .popup{\n      outline:calc(1.5px * var(--scale-factor)) solid CanvasText !important;\n      background-color:ButtonFace !important;\n      color:ButtonText !important;\n    }\n\n    .annotationLayer .highlightArea:hover::after{\n      position:absolute;\n      top:0;\n      left:0;\n      width:100%;\n      height:100%;\n      -webkit-backdrop-filter:var(--hcm-highlight-filter);\n              backdrop-filter:var(--hcm-highlight-filter);\n      content:\"\";\n      pointer-events:none;\n    }\n\n    .annotationLayer .popupAnnotation.focused .popup{\n      outline:calc(3px * var(--scale-factor)) solid Highlight !important;\n    }\n  }\n\n.annotationLayer[data-main-rotation=\"90\"] .norotate{\n    transform:rotate(270deg) translateX(-100%);\n  }\n\n.annotationLayer[data-main-rotation=\"180\"] .norotate{\n    transform:rotate(180deg) translate(-100%, -100%);\n  }\n\n.annotationLayer[data-main-rotation=\"270\"] .norotate{\n    transform:rotate(90deg) translateY(-100%);\n  }\n\n.annotationLayer.disabled section,\n    .annotationLayer.disabled .popup{\n      pointer-events:none;\n    }\n\n.annotationLayer .annotationContent{\n    position:absolute;\n    width:100%;\n    height:100%;\n    pointer-events:none;\n  }\n\n.annotationLayer .annotationContent.freetext{\n      background:transparent;\n      border:none;\n      inset:0;\n      overflow:visible;\n      white-space:nowrap;\n      font:10px sans-serif;\n      line-height:1.35;\n      -webkit-user-select:none;\n         -moz-user-select:none;\n              user-select:none;\n    }\n\n.annotationLayer section{\n    position:absolute;\n    text-align:initial;\n    pointer-events:auto;\n    box-sizing:border-box;\n    transform-origin:0 0;\n  }\n\n.annotationLayer section:has(div.annotationContent) canvas.annotationContent{\n        display:none;\n      }\n\n.annotationLayer :is(.linkAnnotation, .buttonWidgetAnnotation.pushButton) > a{\n    position:absolute;\n    font-size:1em;\n    top:0;\n    left:0;\n    width:100%;\n    height:100%;\n  }\n\n.annotationLayer :is(.linkAnnotation, .buttonWidgetAnnotation.pushButton):not(.hasBorder)\n    > a:hover{\n    opacity:0.2;\n    background-color:rgb(255 255 0);\n    box-shadow:0 2px 10px rgb(255 255 0);\n  }\n\n.annotationLayer .linkAnnotation.hasBorder:hover{\n    background-color:rgb(255 255 0 / 0.2);\n  }\n\n.annotationLayer .hasBorder{\n    background-size:100% 100%;\n  }\n\n.annotationLayer .textAnnotation img{\n    position:absolute;\n    cursor:pointer;\n    width:100%;\n    height:100%;\n    top:0;\n    left:0;\n  }\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea), .annotationLayer .choiceWidgetAnnotation select, .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input{\n    background-image:var(--annotation-unfocused-field-background);\n    border:2px solid var(--input-unfocused-border-color);\n    box-sizing:border-box;\n    font:calc(9px * var(--scale-factor)) sans-serif;\n    height:100%;\n    margin:0;\n    vertical-align:top;\n    width:100%;\n  }\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea):required, .annotationLayer .choiceWidgetAnnotation select:required, .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input:required{\n    outline:1.5px solid red;\n  }\n\n.annotationLayer .choiceWidgetAnnotation select option{\n    padding:0;\n  }\n\n.annotationLayer .buttonWidgetAnnotation.radioButton input{\n    border-radius:50%;\n  }\n\n.annotationLayer .textWidgetAnnotation textarea{\n    resize:none;\n  }\n\n.annotationLayer .textWidgetAnnotation [disabled]:is(input, textarea), .annotationLayer .choiceWidgetAnnotation select[disabled], .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input[disabled]{\n    background:none;\n    border:2px solid var(--input-disabled-border-color);\n    cursor:not-allowed;\n  }\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea):hover, .annotationLayer .choiceWidgetAnnotation select:hover, .annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input:hover{\n    border:2px solid var(--input-hover-border-color);\n  }\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea):hover, .annotationLayer .choiceWidgetAnnotation select:hover, .annotationLayer .buttonWidgetAnnotation.checkBox input:hover{\n    border-radius:2px;\n  }\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea):focus, .annotationLayer .choiceWidgetAnnotation select:focus{\n    background:none;\n    border:2px solid var(--input-focus-border-color);\n    border-radius:2px;\n    outline:var(--input-focus-outline);\n  }\n\n.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) :focus{\n    background-image:none;\n    background-color:transparent;\n  }\n\n.annotationLayer .buttonWidgetAnnotation.checkBox :focus{\n    border:2px solid var(--input-focus-border-color);\n    border-radius:2px;\n    outline:var(--input-focus-outline);\n  }\n\n.annotationLayer .buttonWidgetAnnotation.radioButton :focus{\n    border:2px solid var(--input-focus-border-color);\n    outline:var(--input-focus-outline);\n  }\n\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after,\n  .annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before{\n    background-color:CanvasText;\n    content:\"\";\n    display:block;\n    position:absolute;\n  }\n\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after{\n    height:80%;\n    left:45%;\n    width:1px;\n  }\n\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before{\n    transform:rotate(45deg);\n  }\n\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after{\n    transform:rotate(-45deg);\n  }\n\n.annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before{\n    border-radius:50%;\n    height:50%;\n    left:25%;\n    top:25%;\n    width:50%;\n  }\n\n.annotationLayer .textWidgetAnnotation input.comb{\n    font-family:monospace;\n    padding-left:2px;\n    padding-right:0;\n  }\n\n.annotationLayer .textWidgetAnnotation input.comb:focus{\n    width:103%;\n  }\n\n.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input{\n    -webkit-appearance:none;\n       -moz-appearance:none;\n            appearance:none;\n  }\n\n.annotationLayer .fileAttachmentAnnotation .popupTriggerArea{\n    height:100%;\n    width:100%;\n  }\n\n.annotationLayer .popupAnnotation{\n    position:absolute;\n    font-size:calc(9px * var(--scale-factor));\n    pointer-events:none;\n    width:-moz-max-content;\n    width:max-content;\n    max-width:45%;\n    height:auto;\n  }\n\n.annotationLayer .popup{\n    background-color:rgb(255 255 153);\n    box-shadow:0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor)) rgb(136 136 136);\n    border-radius:calc(2px * var(--scale-factor));\n    outline:1.5px solid rgb(255 255 74);\n    padding:calc(6px * var(--scale-factor));\n    cursor:pointer;\n    font:message-box;\n    white-space:normal;\n    word-wrap:break-word;\n    pointer-events:auto;\n  }\n\n.annotationLayer .popupAnnotation.focused .popup{\n    outline-width:3px;\n  }\n\n.annotationLayer .popup *{\n    font-size:calc(9px * var(--scale-factor));\n  }\n\n.annotationLayer .popup > .header{\n    display:inline-block;\n  }\n\n.annotationLayer .popup > .header h1{\n    display:inline;\n  }\n\n.annotationLayer .popup > .header .popupDate{\n    display:inline-block;\n    margin-left:calc(5px * var(--scale-factor));\n    width:-moz-fit-content;\n    width:fit-content;\n  }\n\n.annotationLayer .popupContent{\n    border-top:1px solid rgb(51 51 51);\n    margin-top:calc(2px * var(--scale-factor));\n    padding-top:calc(2px * var(--scale-factor));\n  }\n\n.annotationLayer .richText > *{\n    white-space:pre-wrap;\n    font-size:calc(9px * var(--scale-factor));\n  }\n\n.annotationLayer .popupTriggerArea{\n    cursor:pointer;\n  }\n\n.annotationLayer section svg{\n    position:absolute;\n    width:100%;\n    height:100%;\n    top:0;\n    left:0;\n  }\n\n.annotationLayer .annotationTextContent{\n    position:absolute;\n    width:100%;\n    height:100%;\n    opacity:0;\n    color:transparent;\n    -webkit-user-select:none;\n       -moz-user-select:none;\n            user-select:none;\n    pointer-events:none;\n  }\n\n.annotationLayer .annotationTextContent span{\n      width:100%;\n      display:inline-block;\n    }\n\n.annotationLayer svg.quadrilateralsContainer{\n    contain:strict;\n    width:0;\n    height:0;\n    position:absolute;\n    top:0;\n    left:0;\n    z-index:-1;\n  }\n\n:root{\n  --xfa-unfocused-field-background:url(\"data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>\");\n  --xfa-focus-outline:auto;\n}\n\n@media screen and (forced-colors: active){\n  :root{\n    --xfa-focus-outline:2px solid CanvasText;\n  }\n  .xfaLayer *:required{\n    outline:1.5px solid selectedItem;\n  }\n}\n\n.xfaLayer{\n  background-color:transparent;\n}\n\n.xfaLayer .highlight{\n  margin:-1px;\n  padding:1px;\n  background-color:rgb(239 203 237);\n  border-radius:4px;\n}\n\n.xfaLayer .highlight.appended{\n  position:initial;\n}\n\n.xfaLayer .highlight.begin{\n  border-radius:4px 0 0 4px;\n}\n\n.xfaLayer .highlight.end{\n  border-radius:0 4px 4px 0;\n}\n\n.xfaLayer .highlight.middle{\n  border-radius:0;\n}\n\n.xfaLayer .highlight.selected{\n  background-color:rgb(203 223 203);\n}\n\n.xfaPage{\n  overflow:hidden;\n  position:relative;\n}\n\n.xfaContentarea{\n  position:absolute;\n}\n\n.xfaPrintOnly{\n  display:none;\n}\n\n.xfaLayer{\n  position:absolute;\n  text-align:initial;\n  top:0;\n  left:0;\n  transform-origin:0 0;\n  line-height:1.2;\n}\n\n.xfaLayer *{\n  color:inherit;\n  font:inherit;\n  font-style:inherit;\n  font-weight:inherit;\n  font-kerning:inherit;\n  letter-spacing:-0.01px;\n  text-align:inherit;\n  text-decoration:inherit;\n  box-sizing:border-box;\n  background-color:transparent;\n  padding:0;\n  margin:0;\n  pointer-events:auto;\n  line-height:inherit;\n}\n\n.xfaLayer *:required{\n  outline:1.5px solid red;\n}\n\n.xfaLayer div,\n.xfaLayer svg,\n.xfaLayer svg *{\n  pointer-events:none;\n}\n\n.xfaLayer a{\n  color:blue;\n}\n\n.xfaRich li{\n  margin-left:3em;\n}\n\n.xfaFont{\n  color:black;\n  font-weight:normal;\n  font-kerning:none;\n  font-size:10px;\n  font-style:normal;\n  letter-spacing:0;\n  text-decoration:none;\n  vertical-align:0;\n}\n\n.xfaCaption{\n  overflow:hidden;\n  flex:0 0 auto;\n}\n\n.xfaCaptionForCheckButton{\n  overflow:hidden;\n  flex:1 1 auto;\n}\n\n.xfaLabel{\n  height:100%;\n  width:100%;\n}\n\n.xfaLeft{\n  display:flex;\n  flex-direction:row;\n  align-items:center;\n}\n\n.xfaRight{\n  display:flex;\n  flex-direction:row-reverse;\n  align-items:center;\n}\n\n:is(.xfaLeft, .xfaRight) > :is(.xfaCaption, .xfaCaptionForCheckButton){\n  max-height:100%;\n}\n\n.xfaTop{\n  display:flex;\n  flex-direction:column;\n  align-items:flex-start;\n}\n\n.xfaBottom{\n  display:flex;\n  flex-direction:column-reverse;\n  align-items:flex-start;\n}\n\n:is(.xfaTop, .xfaBottom) > :is(.xfaCaption, .xfaCaptionForCheckButton){\n  width:100%;\n}\n\n.xfaBorder{\n  background-color:transparent;\n  position:absolute;\n  pointer-events:none;\n}\n\n.xfaWrapped{\n  width:100%;\n  height:100%;\n}\n\n:is(.xfaTextfield, .xfaSelect):focus{\n  background-image:none;\n  background-color:transparent;\n  outline:var(--xfa-focus-outline);\n  outline-offset:-1px;\n}\n\n:is(.xfaCheckbox, .xfaRadio):focus{\n  outline:var(--xfa-focus-outline);\n}\n\n.xfaTextfield,\n.xfaSelect{\n  height:100%;\n  width:100%;\n  flex:1 1 auto;\n  border:none;\n  resize:none;\n  background-image:var(--xfa-unfocused-field-background);\n}\n\n.xfaSelect{\n  padding-inline:2px;\n}\n\n:is(.xfaTop, .xfaBottom) > :is(.xfaTextfield, .xfaSelect){\n  flex:0 1 auto;\n}\n\n.xfaButton{\n  cursor:pointer;\n  width:100%;\n  height:100%;\n  border:none;\n  text-align:center;\n}\n\n.xfaLink{\n  width:100%;\n  height:100%;\n  position:absolute;\n  top:0;\n  left:0;\n}\n\n.xfaCheckbox,\n.xfaRadio{\n  width:100%;\n  height:100%;\n  flex:0 0 auto;\n  border:none;\n}\n\n.xfaRich{\n  white-space:pre-wrap;\n  width:100%;\n  height:100%;\n}\n\n.xfaImage{\n  -o-object-position:left top;\n     object-position:left top;\n  -o-object-fit:contain;\n     object-fit:contain;\n  width:100%;\n  height:100%;\n}\n\n.xfaLrTb,\n.xfaRlTb,\n.xfaTb{\n  display:flex;\n  flex-direction:column;\n  align-items:stretch;\n}\n\n.xfaLr{\n  display:flex;\n  flex-direction:row;\n  align-items:stretch;\n}\n\n.xfaRl{\n  display:flex;\n  flex-direction:row-reverse;\n  align-items:stretch;\n}\n\n.xfaTb > div{\n  justify-content:left;\n}\n\n.xfaPosition{\n  position:relative;\n}\n\n.xfaArea{\n  position:relative;\n}\n\n.xfaValignMiddle{\n  display:flex;\n  align-items:center;\n}\n\n.xfaTable{\n  display:flex;\n  flex-direction:column;\n  align-items:stretch;\n}\n\n.xfaTable .xfaRow{\n  display:flex;\n  flex-direction:row;\n  align-items:stretch;\n}\n\n.xfaTable .xfaRlRow{\n  display:flex;\n  flex-direction:row-reverse;\n  align-items:stretch;\n  flex:1;\n}\n\n.xfaTable .xfaRlRow > div{\n  flex:1;\n}\n\n:is(.xfaNonInteractive, .xfaDisabled, .xfaReadOnly) :is(input, textarea){\n  background:initial;\n}\n\n@media print{\n  .xfaTextfield,\n  .xfaSelect{\n    background:transparent;\n  }\n\n  .xfaSelect{\n    -webkit-appearance:none;\n       -moz-appearance:none;\n            appearance:none;\n    text-indent:1px;\n    text-overflow:\"\";\n  }\n}\n\n.canvasWrapper svg{\n    transform:none;\n  }\n\n.canvasWrapper svg[data-main-rotation=\"90\"] mask,\n      .canvasWrapper svg[data-main-rotation=\"90\"] use:not(.clip, .mask){\n        transform:matrix(0, 1, -1, 0, 1, 0);\n      }\n\n.canvasWrapper svg[data-main-rotation=\"180\"] mask,\n      .canvasWrapper svg[data-main-rotation=\"180\"] use:not(.clip, .mask){\n        transform:matrix(-1, 0, 0, -1, 1, 1);\n      }\n\n.canvasWrapper svg[data-main-rotation=\"270\"] mask,\n      .canvasWrapper svg[data-main-rotation=\"270\"] use:not(.clip, .mask){\n        transform:matrix(0, -1, 1, 0, 0, 1);\n      }\n\n.canvasWrapper svg.highlight{\n      --blend-mode:multiply;\n\n      position:absolute;\n      mix-blend-mode:var(--blend-mode);\n    }\n\n@media screen and (forced-colors: active){\n\n.canvasWrapper svg.highlight{\n        --blend-mode:difference;\n    }\n      }\n\n.canvasWrapper svg.highlight:not(.free){\n        fill-rule:evenodd;\n      }\n\n.canvasWrapper svg.highlightOutline{\n      position:absolute;\n      mix-blend-mode:normal;\n      fill-rule:evenodd;\n      fill:none;\n    }\n\n.canvasWrapper svg.highlightOutline.hovered:not(.free):not(.selected){\n          stroke:var(--hover-outline-color);\n          stroke-width:var(--outline-width);\n        }\n\n.canvasWrapper svg.highlightOutline.selected:not(.free) .mainOutline{\n            stroke:var(--outline-around-color);\n            stroke-width:calc(\n              var(--outline-width) + 2 * var(--outline-around-width)\n            );\n          }\n\n.canvasWrapper svg.highlightOutline.selected:not(.free) .secondaryOutline{\n            stroke:var(--outline-color);\n            stroke-width:var(--outline-width);\n          }\n\n.canvasWrapper svg.highlightOutline.free.hovered:not(.selected){\n          stroke:var(--hover-outline-color);\n          stroke-width:calc(2 * var(--outline-width));\n        }\n\n.canvasWrapper svg.highlightOutline.free.selected .mainOutline{\n            stroke:var(--outline-around-color);\n            stroke-width:calc(\n              2 * (var(--outline-width) + var(--outline-around-width))\n            );\n          }\n\n.canvasWrapper svg.highlightOutline.free.selected .secondaryOutline{\n            stroke:var(--outline-color);\n            stroke-width:calc(2 * var(--outline-width));\n          }\n\n.toggle-button{\n  --button-background-color:#f0f0f4;\n  --button-background-color-hover:#e0e0e6;\n  --button-background-color-active:#cfcfd8;\n  --color-accent-primary:#0060df;\n  --color-accent-primary-hover:#0250bb;\n  --color-accent-primary-active:#054096;\n  --border-interactive-color:#8f8f9d;\n  --border-radius-circle:9999px;\n  --border-width:1px;\n  --size-item-small:16px;\n  --size-item-large:32px;\n  --color-canvas:white;\n\n  --toggle-background-color:var(--button-background-color);\n  --toggle-background-color-hover:var(--button-background-color-hover);\n  --toggle-background-color-active:var(--button-background-color-active);\n  --toggle-background-color-pressed:var(--color-accent-primary);\n  --toggle-background-color-pressed-hover:var(--color-accent-primary-hover);\n  --toggle-background-color-pressed-active:var(--color-accent-primary-active);\n  --toggle-border-color:var(--border-interactive-color);\n  --toggle-border-color-hover:var(--toggle-border-color);\n  --toggle-border-color-active:var(--toggle-border-color);\n  --toggle-border-radius:var(--border-radius-circle);\n  --toggle-border-width:var(--border-width);\n  --toggle-height:var(--size-item-small);\n  --toggle-width:var(--size-item-large);\n  --toggle-dot-background-color:var(--toggle-border-color);\n  --toggle-dot-background-color-hover:var(--toggle-dot-background-color);\n  --toggle-dot-background-color-active:var(--toggle-dot-background-color);\n  --toggle-dot-background-color-on-pressed:var(--color-canvas);\n  --toggle-dot-margin:1px;\n  --toggle-dot-height:calc(\n    var(--toggle-height) - 2 * var(--toggle-dot-margin) - 2 *\n      var(--toggle-border-width)\n  );\n  --toggle-dot-width:var(--toggle-dot-height);\n  --toggle-dot-transform-x:calc(\n    var(--toggle-width) - 4 * var(--toggle-dot-margin) - var(--toggle-dot-width)\n  );\n\n  -webkit-appearance:none;\n\n     -moz-appearance:none;\n\n          appearance:none;\n  padding:0;\n  margin:0;\n  border:var(--toggle-border-width) solid var(--toggle-border-color);\n  height:var(--toggle-height);\n  width:var(--toggle-width);\n  border-radius:var(--toggle-border-radius);\n  background:var(--toggle-background-color);\n  box-sizing:border-box;\n  flex-shrink:0;\n}\n\n@media (prefers-color-scheme: dark){\n\n.toggle-button{\n    --button-background-color:color-mix(in srgb, currentColor 7%, transparent);\n    --button-background-color-hover:color-mix(\n      in srgb,\n      currentColor 14%,\n      transparent\n    );\n    --button-background-color-active:color-mix(\n      in srgb,\n      currentColor 21%,\n      transparent\n    );\n    --color-accent-primary:#0df;\n    --color-accent-primary-hover:#80ebff;\n    --color-accent-primary-active:#aaf2ff;\n    --border-interactive-color:#bfbfc9;\n    --color-canvas:#1c1b22;\n}\n  }\n\n@media (forced-colors: active){\n\n.toggle-button{\n    --color-accent-primary:ButtonText;\n    --color-accent-primary-hover:SelectedItem;\n    --color-accent-primary-active:SelectedItem;\n    --border-interactive-color:ButtonText;\n    --button-background-color:ButtonFace;\n    --border-interactive-color-hover:SelectedItem;\n    --border-interactive-color-active:SelectedItem;\n    --border-interactive-color-disabled:GrayText;\n    --color-canvas:ButtonText;\n}\n  }\n\n.toggle-button:focus-visible{\n    outline:var(--focus-outline);\n    outline-offset:var(--focus-outline-offset);\n  }\n\n.toggle-button:enabled:hover{\n    background:var(--toggle-background-color-hover);\n    border-color:var(--toggle-border-color);\n  }\n\n.toggle-button:enabled:active{\n    background:var(--toggle-background-color-active);\n    border-color:var(--toggle-border-color);\n  }\n\n.toggle-button[aria-pressed=\"true\"]{\n    background:var(--toggle-background-color-pressed);\n    border-color:transparent;\n  }\n\n.toggle-button[aria-pressed=\"true\"]:enabled:hover{\n    background:var(--toggle-background-color-pressed-hover);\n    border-color:transparent;\n  }\n\n.toggle-button[aria-pressed=\"true\"]:enabled:active{\n    background:var(--toggle-background-color-pressed-active);\n    border-color:transparent;\n  }\n\n.toggle-button::before{\n    display:block;\n    content:\"\";\n    background-color:var(--toggle-dot-background-color);\n    height:var(--toggle-dot-height);\n    width:var(--toggle-dot-width);\n    margin:var(--toggle-dot-margin);\n    border-radius:var(--toggle-border-radius);\n    translate:0;\n  }\n\n.toggle-button[aria-pressed=\"true\"]::before{\n    translate:var(--toggle-dot-transform-x);\n    background-color:var(--toggle-dot-background-color-on-pressed);\n  }\n\n.toggle-button[aria-pressed=\"true\"]:enabled:hover::before,\n  .toggle-button[aria-pressed=\"true\"]:enabled:active::before{\n    background-color:var(--toggle-dot-background-color-on-pressed);\n  }\n\n[dir=\"rtl\"] .toggle-button[aria-pressed=\"true\"]::before{\n    translate:calc(-1 * var(--toggle-dot-transform-x));\n  }\n\n@media (prefers-reduced-motion: no-preference){\n    .toggle-button::before{\n      transition:translate 100ms;\n    }\n  }\n\n@media (prefers-contrast){\n    .toggle-button:enabled:hover{\n      border-color:var(--toggle-border-color-hover);\n    }\n\n    .toggle-button:enabled:active{\n      border-color:var(--toggle-border-color-active);\n    }\n\n    .toggle-button[aria-pressed=\"true\"]:enabled{\n      border-color:var(--toggle-border-color);\n      position:relative;\n    }\n\n    .toggle-button[aria-pressed=\"true\"]:enabled:hover,\n    .toggle-button[aria-pressed=\"true\"]:enabled:hover:active{\n      border-color:var(--toggle-border-color-hover);\n    }\n\n    .toggle-button[aria-pressed=\"true\"]:enabled:active{\n      background-color:var(--toggle-dot-background-color-active);\n      border-color:var(--toggle-dot-background-color-hover);\n    }\n\n    .toggle-button:hover::before,\n    .toggle-button:active::before{\n      background-color:var(--toggle-dot-background-color-hover);\n    }\n  }\n\n@media (forced-colors){\n\n.toggle-button{\n    --toggle-dot-background-color:var(--color-accent-primary);\n    --toggle-dot-background-color-hover:var(--color-accent-primary-hover);\n    --toggle-dot-background-color-active:var(--color-accent-primary-active);\n    --toggle-dot-background-color-on-pressed:var(--button-background-color);\n    --toggle-background-color-disabled:var(--button-background-color-disabled);\n    --toggle-border-color-hover:var(--border-interactive-color-hover);\n    --toggle-border-color-active:var(--border-interactive-color-active);\n    --toggle-border-color-disabled:var(--border-interactive-color-disabled);\n}\n\n    .toggle-button[aria-pressed=\"true\"]:enabled::after{\n      border:1px solid var(--button-background-color);\n      content:\"\";\n      position:absolute;\n      height:var(--toggle-height);\n      width:var(--toggle-width);\n      display:block;\n      border-radius:var(--toggle-border-radius);\n      inset:-2px;\n    }\n\n    .toggle-button[aria-pressed=\"true\"]:enabled:active::after{\n      border-color:var(--toggle-border-color-active);\n    }\n  }\n\n:root{\n  --outline-width:2px;\n  --outline-color:#0060df;\n  --outline-around-width:1px;\n  --outline-around-color:#f0f0f4;\n  --hover-outline-around-color:var(--outline-around-color);\n  --focus-outline:solid var(--outline-width) var(--outline-color);\n  --unfocus-outline:solid var(--outline-width) transparent;\n  --focus-outline-around:solid var(--outline-around-width) var(--outline-around-color);\n  --hover-outline-color:#8f8f9d;\n  --hover-outline:solid var(--outline-width) var(--hover-outline-color);\n  --hover-outline-around:solid var(--outline-around-width) var(--hover-outline-around-color);\n  --freetext-line-height:1.35;\n  --freetext-padding:2px;\n  --resizer-bg-color:var(--outline-color);\n  --resizer-size:6px;\n  --resizer-shift:calc(\n    0px - (var(--outline-width) + var(--resizer-size)) / 2 -\n      var(--outline-around-width)\n  );\n  --editorFreeText-editing-cursor:text;\n  --editorInk-editing-cursor:url(images/cursor-editorInk.svg) 0 16, pointer;\n  --editorHighlight-editing-cursor:url(images/cursor-editorTextHighlight.svg) 24 24, text;\n  --editorFreeHighlight-editing-cursor:url(images/cursor-editorFreeHighlight.svg) 1 18, pointer;\n}\n.visuallyHidden{\n  position:absolute;\n  top:0;\n  left:0;\n  border:0;\n  margin:0;\n  padding:0;\n  width:0;\n  height:0;\n  overflow:hidden;\n  white-space:nowrap;\n  font-size:0;\n}\n\n.textLayer.highlighting{\n  cursor:var(--editorFreeHighlight-editing-cursor);\n}\n\n.textLayer.highlighting:not(.free) span{\n    cursor:var(--editorHighlight-editing-cursor);\n  }\n\n.textLayer.highlighting.free span{\n    cursor:var(--editorFreeHighlight-editing-cursor);\n  }\n\n@media (min-resolution: 1.1dppx){\n  :root{\n    --editorFreeText-editing-cursor:url(images/cursor-editorFreeText.svg) 0 16, text;\n  }\n}\n\n@media screen and (forced-colors: active){\n  :root{\n    --outline-color:CanvasText;\n    --outline-around-color:ButtonFace;\n    --resizer-bg-color:ButtonText;\n    --hover-outline-color:Highlight;\n    --hover-outline-around-color:SelectedItemText;\n  }\n}\n\n[data-editor-rotation=\"90\"]{\n  transform:rotate(90deg);\n}\n\n[data-editor-rotation=\"180\"]{\n  transform:rotate(180deg);\n}\n\n[data-editor-rotation=\"270\"]{\n  transform:rotate(270deg);\n}\n\n.annotationEditorLayer{\n  background:transparent;\n  position:absolute;\n  inset:0;\n  font-size:calc(100px * var(--scale-factor));\n  transform-origin:0 0;\n  cursor:auto;\n}\n\n.annotationEditorLayer.waiting{\n  content:\"\";\n  cursor:wait;\n  position:absolute;\n  inset:0;\n  width:100%;\n  height:100%;\n}\n\n.annotationEditorLayer.disabled{\n  pointer-events:none;\n}\n\n.annotationEditorLayer.freetextEditing{\n  cursor:var(--editorFreeText-editing-cursor);\n}\n\n.annotationEditorLayer.inkEditing{\n  cursor:var(--editorInk-editing-cursor);\n}\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor){\n  position:absolute;\n  background:transparent;\n  z-index:1;\n  transform-origin:0 0;\n  cursor:auto;\n  max-width:100%;\n  max-height:100%;\n  border:var(--unfocus-outline);\n}\n\n.annotationEditorLayer .draggable.selectedEditor:is(.freeTextEditor, .inkEditor, .stampEditor){\n    cursor:move;\n  }\n\n.annotationEditorLayer .moving:is(.freeTextEditor, .inkEditor, .stampEditor){\n    touch-action:none;\n  }\n\n.annotationEditorLayer .selectedEditor:is(.freeTextEditor, .inkEditor, .stampEditor){\n    border:var(--focus-outline);\n    outline:var(--focus-outline-around);\n  }\n\n.annotationEditorLayer .selectedEditor:is(.freeTextEditor, .inkEditor, .stampEditor)::before{\n      content:\"\";\n      position:absolute;\n      inset:0;\n      border:var(--focus-outline-around);\n      pointer-events:none;\n    }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor):hover:not(.selectedEditor){\n    border:var(--hover-outline);\n    outline:var(--hover-outline-around);\n  }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor):hover:not(.selectedEditor)::before{\n      content:\"\";\n      position:absolute;\n      inset:0;\n      border:var(--focus-outline-around);\n    }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{\n    --editor-toolbar-delete-image:url(images/editor-toolbar-delete.svg);\n    --editor-toolbar-bg-color:#f0f0f4;\n    --editor-toolbar-highlight-image:url(images/toolbarButton-editorHighlight.svg);\n    --editor-toolbar-fg-color:#2e2e56;\n    --editor-toolbar-border-color:#8f8f9d;\n    --editor-toolbar-hover-border-color:var(--editor-toolbar-border-color);\n    --editor-toolbar-hover-bg-color:#e0e0e6;\n    --editor-toolbar-hover-fg-color:var(--editor-toolbar-fg-color);\n    --editor-toolbar-hover-outline:none;\n    --editor-toolbar-focus-outline-color:#0060df;\n    --editor-toolbar-shadow:0 2px 6px 0 rgb(58 57 68 / 0.2);\n    --editor-toolbar-vert-offset:6px;\n    --editor-toolbar-height:28px;\n    --editor-toolbar-padding:2px;\n\n    display:flex;\n    width:-moz-fit-content;\n    width:fit-content;\n    height:var(--editor-toolbar-height);\n    flex-direction:column;\n    justify-content:center;\n    align-items:center;\n    cursor:default;\n    pointer-events:auto;\n    box-sizing:content-box;\n    padding:var(--editor-toolbar-padding);\n\n    position:absolute;\n    inset-inline-end:0;\n    inset-block-start:calc(100% + var(--editor-toolbar-vert-offset));\n\n    border-radius:6px;\n    background-color:var(--editor-toolbar-bg-color);\n    border:1px solid var(--editor-toolbar-border-color);\n    box-shadow:var(--editor-toolbar-shadow);\n  }\n\n@media (prefers-color-scheme: dark){\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{\n      --editor-toolbar-bg-color:#2b2a33;\n      --editor-toolbar-fg-color:#fbfbfe;\n      --editor-toolbar-hover-bg-color:#52525e;\n      --editor-toolbar-focus-outline-color:#0df;\n  }\n    }\n\n@media screen and (forced-colors: active){\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{\n      --editor-toolbar-bg-color:ButtonFace;\n      --editor-toolbar-fg-color:ButtonText;\n      --editor-toolbar-border-color:ButtonText;\n      --editor-toolbar-hover-border-color:AccentColor;\n      --editor-toolbar-hover-bg-color:ButtonFace;\n      --editor-toolbar-hover-fg-color:AccentColor;\n      --editor-toolbar-hover-outline:2px solid var(--editor-toolbar-hover-border-color);\n      --editor-toolbar-focus-outline-color:ButtonBorder;\n      --editor-toolbar-shadow:none;\n  }\n    }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar.hidden{\n      display:none;\n    }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar:has(:focus-visible){\n      border-color:transparent;\n    }\n\n[dir=\"ltr\"] :is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{\n      transform-origin:100% 0;\n    }\n\n[dir=\"rtl\"] :is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar{\n      transform-origin:0 0;\n    }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons{\n      display:flex;\n      justify-content:center;\n      align-items:center;\n      gap:0;\n      height:100%;\n    }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .divider{\n        width:1px;\n        height:calc(\n          2 * var(--editor-toolbar-padding) + var(--editor-toolbar-height)\n        );\n        background-color:var(--editor-toolbar-border-color);\n        display:inline-block;\n        margin-inline:2px;\n      }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .highlightButton{\n        width:var(--editor-toolbar-height);\n      }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .highlightButton::before{\n          content:\"\";\n          -webkit-mask-image:var(--editor-toolbar-highlight-image);\n                  mask-image:var(--editor-toolbar-highlight-image);\n          -webkit-mask-repeat:no-repeat;\n                  mask-repeat:no-repeat;\n          -webkit-mask-position:center;\n                  mask-position:center;\n          display:inline-block;\n          background-color:var(--editor-toolbar-fg-color);\n          width:100%;\n          height:100%;\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .highlightButton:hover::before{\n          background-color:var(--editor-toolbar-hover-fg-color);\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .delete{\n        width:var(--editor-toolbar-height);\n      }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .delete::before{\n          content:\"\";\n          -webkit-mask-image:var(--editor-toolbar-delete-image);\n                  mask-image:var(--editor-toolbar-delete-image);\n          -webkit-mask-repeat:no-repeat;\n                  mask-repeat:no-repeat;\n          -webkit-mask-position:center;\n                  mask-position:center;\n          display:inline-block;\n          background-color:var(--editor-toolbar-fg-color);\n          width:100%;\n          height:100%;\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .delete:hover::before{\n          background-color:var(--editor-toolbar-hover-fg-color);\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > *{\n        height:var(--editor-toolbar-height);\n      }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > :not(.divider){\n        border:none;\n        background-color:transparent;\n        cursor:pointer;\n      }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > :not(.divider):hover{\n          border-radius:2px;\n          background-color:var(--editor-toolbar-hover-bg-color);\n          color:var(--editor-toolbar-hover-fg-color);\n          outline:var(--editor-toolbar-hover-outline);\n          outline-offset:1px;\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > :not(.divider):hover:active{\n            outline:none;\n          }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons > :not(.divider):focus-visible{\n          border-radius:2px;\n          outline:2px solid var(--editor-toolbar-focus-outline-color);\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText{\n        --alt-text-add-image:url(images/altText_add.svg);\n        --alt-text-done-image:url(images/altText_done.svg);\n\n        display:flex;\n        align-items:center;\n        justify-content:center;\n        width:-moz-max-content;\n        width:max-content;\n        padding-inline:8px;\n        pointer-events:all;\n        font:menu;\n        font-weight:590;\n        font-size:12px;\n        color:var(--editor-toolbar-fg-color);\n      }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText:disabled{\n          pointer-events:none;\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText::before{\n          content:\"\";\n          -webkit-mask-image:var(--alt-text-add-image);\n                  mask-image:var(--alt-text-add-image);\n          -webkit-mask-repeat:no-repeat;\n                  mask-repeat:no-repeat;\n          -webkit-mask-position:center;\n                  mask-position:center;\n          display:inline-block;\n          width:12px;\n          height:13px;\n          background-color:var(--editor-toolbar-fg-color);\n          margin-inline-end:4px;\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText:hover::before{\n          background-color:var(--editor-toolbar-hover-fg-color);\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText.done::before{\n          -webkit-mask-image:var(--alt-text-done-image);\n                  mask-image:var(--alt-text-done-image);\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText .tooltip{\n          display:none;\n        }\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText .tooltip.show{\n            --alt-text-tooltip-bg:#f0f0f4;\n            --alt-text-tooltip-fg:#15141a;\n            --alt-text-tooltip-border:#8f8f9d;\n            --alt-text-tooltip-shadow:0px 2px 6px 0px rgb(58 57 68 / 0.2);\n\n            display:inline-flex;\n            flex-direction:column;\n            align-items:center;\n            justify-content:center;\n            position:absolute;\n            top:calc(100% + 2px);\n            inset-inline-start:0;\n            padding-block:2px 3px;\n            padding-inline:3px;\n            max-width:300px;\n            width:-moz-max-content;\n            width:max-content;\n            height:auto;\n            font-size:12px;\n\n            border:0.5px solid var(--alt-text-tooltip-border);\n            background:var(--alt-text-tooltip-bg);\n            box-shadow:var(--alt-text-tooltip-shadow);\n            color:var(--alt-text-tooltip-fg);\n\n            pointer-events:none;\n          }\n\n@media (prefers-color-scheme: dark){\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText .tooltip.show{\n              --alt-text-tooltip-bg:#1c1b22;\n              --alt-text-tooltip-fg:#fbfbfe;\n              --alt-text-tooltip-shadow:0px 2px 6px 0px #15141a;\n          }\n            }\n\n@media screen and (forced-colors: active){\n\n:is(.annotationEditorLayer\n  :is(.freeTextEditor, .inkEditor, .stampEditor, .highlightEditor),.textLayer) .editToolbar .buttons .altText .tooltip.show{\n              --alt-text-tooltip-bg:Canvas;\n              --alt-text-tooltip-fg:CanvasText;\n              --alt-text-tooltip-border:CanvasText;\n              --alt-text-tooltip-shadow:none;\n          }\n            }\n\n.annotationEditorLayer .freeTextEditor{\n  padding:calc(var(--freetext-padding) * var(--scale-factor));\n  width:auto;\n  height:auto;\n  touch-action:none;\n}\n\n.annotationEditorLayer .freeTextEditor .internal{\n  background:transparent;\n  border:none;\n  inset:0;\n  overflow:visible;\n  white-space:nowrap;\n  font:10px sans-serif;\n  line-height:var(--freetext-line-height);\n  -webkit-user-select:none;\n     -moz-user-select:none;\n          user-select:none;\n}\n\n.annotationEditorLayer .freeTextEditor .overlay{\n  position:absolute;\n  display:none;\n  background:transparent;\n  inset:0;\n  width:100%;\n  height:100%;\n}\n\n.annotationEditorLayer freeTextEditor .overlay.enabled{\n  display:block;\n}\n\n.annotationEditorLayer .freeTextEditor .internal:empty::before{\n  content:attr(default-content);\n  color:gray;\n}\n\n.annotationEditorLayer .freeTextEditor .internal:focus{\n  outline:none;\n  -webkit-user-select:auto;\n     -moz-user-select:auto;\n          user-select:auto;\n}\n\n.annotationEditorLayer .inkEditor{\n  width:100%;\n  height:100%;\n}\n\n.annotationEditorLayer .inkEditor.editing{\n  cursor:inherit;\n}\n\n.annotationEditorLayer .inkEditor .inkEditorCanvas{\n  position:absolute;\n  inset:0;\n  width:100%;\n  height:100%;\n  touch-action:none;\n}\n\n.annotationEditorLayer .stampEditor{\n  width:auto;\n  height:auto;\n}\n\n.annotationEditorLayer .stampEditor canvas{\n    position:absolute;\n    width:100%;\n    height:100%;\n    margin:0;\n  }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers{\n      position:absolute;\n      inset:0;\n    }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers.hidden{\n        display:none;\n      }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer{\n        width:var(--resizer-size);\n        height:var(--resizer-size);\n        background:content-box var(--resizer-bg-color);\n        border:var(--focus-outline-around);\n        border-radius:2px;\n        position:absolute;\n      }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.topLeft{\n          top:var(--resizer-shift);\n          left:var(--resizer-shift);\n        }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.topMiddle{\n          top:var(--resizer-shift);\n          left:calc(50% + var(--resizer-shift));\n        }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.topRight{\n          top:var(--resizer-shift);\n          right:var(--resizer-shift);\n        }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.middleRight{\n          top:calc(50% + var(--resizer-shift));\n          right:var(--resizer-shift);\n        }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.bottomRight{\n          bottom:var(--resizer-shift);\n          right:var(--resizer-shift);\n        }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.bottomMiddle{\n          bottom:var(--resizer-shift);\n          left:calc(50% + var(--resizer-shift));\n        }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.bottomLeft{\n          bottom:var(--resizer-shift);\n          left:var(--resizer-shift);\n        }\n\n.annotationEditorLayer :is(.freeTextEditor, .inkEditor, .stampEditor) > .resizers > .resizer.middleLeft{\n          top:calc(50% + var(--resizer-shift));\n          left:var(--resizer-shift);\n        }\n\n.annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.topLeft,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.topLeft,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.topLeft,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.topLeft,\n      .annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.bottomRight,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.bottomRight,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.bottomRight,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.bottomRight{\n        cursor:nwse-resize;\n      }\n\n.annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.topMiddle,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.topMiddle,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.topMiddle,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.topMiddle,\n      .annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.bottomMiddle,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.bottomMiddle,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.bottomMiddle,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.bottomMiddle{\n        cursor:ns-resize;\n      }\n\n.annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.topRight,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.topRight,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.topRight,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.topRight,\n      .annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.bottomLeft,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.bottomLeft,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.bottomLeft,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.bottomLeft{\n        cursor:nesw-resize;\n      }\n\n.annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.middleRight,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.middleRight,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.middleRight,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.middleRight,\n      .annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.middleLeft,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.middleLeft,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.middleLeft,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.middleLeft{\n        cursor:ew-resize;\n      }\n\n.annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.topLeft,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.topLeft,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.topLeft,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.topLeft,\n      .annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.bottomRight,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.bottomRight,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.bottomRight,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.bottomRight{\n        cursor:nesw-resize;\n      }\n\n.annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.topMiddle,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.topMiddle,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.topMiddle,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.topMiddle,\n      .annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.bottomMiddle,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.bottomMiddle,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.bottomMiddle,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.bottomMiddle{\n        cursor:ew-resize;\n      }\n\n.annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.topRight,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.topRight,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.topRight,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.topRight,\n      .annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.bottomLeft,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.bottomLeft,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.bottomLeft,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.bottomLeft{\n        cursor:nwse-resize;\n      }\n\n.annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.middleRight,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.middleRight,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.middleRight,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.middleRight,\n      .annotationEditorLayer[data-main-rotation=\"0\"]\n    :is([data-editor-rotation=\"90\"], [data-editor-rotation=\"270\"]) > .resizers > .resizer.middleLeft,\n      .annotationEditorLayer[data-main-rotation=\"90\"]\n    :is([data-editor-rotation=\"0\"], [data-editor-rotation=\"180\"]) > .resizers > .resizer.middleLeft,\n      .annotationEditorLayer[data-main-rotation=\"180\"]\n    :is([data-editor-rotation=\"270\"], [data-editor-rotation=\"90\"]) > .resizers > .resizer.middleLeft,\n      .annotationEditorLayer[data-main-rotation=\"270\"]\n    :is([data-editor-rotation=\"180\"], [data-editor-rotation=\"0\"]) > .resizers > .resizer.middleLeft{\n        cursor:ns-resize;\n      }\n\n.annotationEditorLayer\n    :is(\n      [data-main-rotation=\"0\"] [data-editor-rotation=\"90\"],\n      [data-main-rotation=\"90\"] [data-editor-rotation=\"0\"],\n      [data-main-rotation=\"180\"] [data-editor-rotation=\"270\"],\n      [data-main-rotation=\"270\"] [data-editor-rotation=\"180\"]\n    ) .editToolbar{\n      rotate:270deg;\n    }\n\n[dir=\"ltr\"] .annotationEditorLayer\n    :is(\n      [data-main-rotation=\"0\"] [data-editor-rotation=\"90\"],\n      [data-main-rotation=\"90\"] [data-editor-rotation=\"0\"],\n      [data-main-rotation=\"180\"] [data-editor-rotation=\"270\"],\n      [data-main-rotation=\"270\"] [data-editor-rotation=\"180\"]\n    ) .editToolbar{\n        inset-inline-end:calc(0px - var(--editor-toolbar-vert-offset));\n        inset-block-start:0;\n      }\n\n[dir=\"rtl\"] .annotationEditorLayer\n    :is(\n      [data-main-rotation=\"0\"] [data-editor-rotation=\"90\"],\n      [data-main-rotation=\"90\"] [data-editor-rotation=\"0\"],\n      [data-main-rotation=\"180\"] [data-editor-rotation=\"270\"],\n      [data-main-rotation=\"270\"] [data-editor-rotation=\"180\"]\n    ) .editToolbar{\n        inset-inline-end:calc(100% + var(--editor-toolbar-vert-offset));\n        inset-block-start:0;\n      }\n\n.annotationEditorLayer\n    :is(\n      [data-main-rotation=\"0\"] [data-editor-rotation=\"180\"],\n      [data-main-rotation=\"90\"] [data-editor-rotation=\"90\"],\n      [data-main-rotation=\"180\"] [data-editor-rotation=\"0\"],\n      [data-main-rotation=\"270\"] [data-editor-rotation=\"270\"]\n    ) .editToolbar{\n      rotate:180deg;\n      inset-inline-end:100%;\n      inset-block-start:calc(0pc - var(--editor-toolbar-vert-offset));\n    }\n\n.annotationEditorLayer\n    :is(\n      [data-main-rotation=\"0\"] [data-editor-rotation=\"270\"],\n      [data-main-rotation=\"90\"] [data-editor-rotation=\"180\"],\n      [data-main-rotation=\"180\"] [data-editor-rotation=\"90\"],\n      [data-main-rotation=\"270\"] [data-editor-rotation=\"0\"]\n    ) .editToolbar{\n      rotate:90deg;\n    }\n\n[dir=\"ltr\"] .annotationEditorLayer\n    :is(\n      [data-main-rotation=\"0\"] [data-editor-rotation=\"270\"],\n      [data-main-rotation=\"90\"] [data-editor-rotation=\"180\"],\n      [data-main-rotation=\"180\"] [data-editor-rotation=\"90\"],\n      [data-main-rotation=\"270\"] [data-editor-rotation=\"0\"]\n    ) .editToolbar{\n        inset-inline-end:calc(100% + var(--editor-toolbar-vert-offset));\n        inset-block-start:100%;\n      }\n\n[dir=\"rtl\"] .annotationEditorLayer\n    :is(\n      [data-main-rotation=\"0\"] [data-editor-rotation=\"270\"],\n      [data-main-rotation=\"90\"] [data-editor-rotation=\"180\"],\n      [data-main-rotation=\"180\"] [data-editor-rotation=\"90\"],\n      [data-main-rotation=\"270\"] [data-editor-rotation=\"0\"]\n    ) .editToolbar{\n        inset-inline-start:calc(0px - var(--editor-toolbar-vert-offset));\n        inset-block-start:0;\n      }\n\n.dialog.altText::backdrop{\n    -webkit-mask:url(#alttext-manager-mask);\n            mask:url(#alttext-manager-mask);\n  }\n\n.dialog.altText.positioned{\n    margin:0;\n  }\n\n.dialog.altText #altTextContainer{\n    width:300px;\n    height:-moz-fit-content;\n    height:fit-content;\n    display:inline-flex;\n    flex-direction:column;\n    align-items:flex-start;\n    gap:16px;\n  }\n\n.dialog.altText #altTextContainer #overallDescription{\n      display:flex;\n      flex-direction:column;\n      align-items:flex-start;\n      gap:4px;\n      align-self:stretch;\n    }\n\n.dialog.altText #altTextContainer #overallDescription span{\n        align-self:stretch;\n      }\n\n.dialog.altText #altTextContainer #overallDescription .title{\n        font-size:13px;\n        font-style:normal;\n        font-weight:590;\n      }\n\n.dialog.altText #altTextContainer #addDescription{\n      display:flex;\n      flex-direction:column;\n      align-items:stretch;\n      gap:8px;\n    }\n\n.dialog.altText #altTextContainer #addDescription .descriptionArea{\n        flex:1;\n        padding-inline:24px 10px;\n      }\n\n.dialog.altText #altTextContainer #addDescription .descriptionArea textarea{\n          width:100%;\n          min-height:75px;\n        }\n\n.dialog.altText #altTextContainer #buttons{\n      display:flex;\n      justify-content:flex-end;\n      align-items:flex-start;\n      gap:8px;\n      align-self:stretch;\n    }\n\n.colorPicker{\n  --hover-outline-color:#0250bb;\n  --selected-outline-color:#0060df;\n  --swatch-border-color:#cfcfd8;\n}\n\n@media (prefers-color-scheme: dark){\n\n.colorPicker{\n    --hover-outline-color:#80ebff;\n    --selected-outline-color:#aaf2ff;\n    --swatch-border-color:#52525e;\n}\n  }\n\n@media screen and (forced-colors: active){\n\n.colorPicker{\n    --hover-outline-color:Highlight;\n    --selected-outline-color:var(--hover-outline-color);\n    --swatch-border-color:ButtonText;\n}\n  }\n\n.colorPicker .swatch{\n    width:16px;\n    height:16px;\n    border:1px solid var(--swatch-border-color);\n    border-radius:100%;\n    outline-offset:2px;\n    box-sizing:border-box;\n    forced-color-adjust:none;\n  }\n\n.colorPicker button:is(:hover, .selected) > .swatch{\n    border:none;\n  }\n\n.annotationEditorLayer[data-main-rotation=\"0\"] .highlightEditor:not(.free) > .editToolbar{\n      rotate:0deg;\n    }\n\n.annotationEditorLayer[data-main-rotation=\"90\"] .highlightEditor:not(.free) > .editToolbar{\n      rotate:270deg;\n    }\n\n.annotationEditorLayer[data-main-rotation=\"180\"] .highlightEditor:not(.free) > .editToolbar{\n      rotate:180deg;\n    }\n\n.annotationEditorLayer[data-main-rotation=\"270\"] .highlightEditor:not(.free) > .editToolbar{\n      rotate:90deg;\n    }\n\n.annotationEditorLayer .highlightEditor{\n    position:absolute;\n    background:transparent;\n    z-index:1;\n    cursor:auto;\n    max-width:100%;\n    max-height:100%;\n    border:none;\n    outline:none;\n    pointer-events:none;\n    transform-origin:0 0;\n  }\n\n.annotationEditorLayer .highlightEditor:not(.free){\n      transform:none;\n    }\n\n.annotationEditorLayer .highlightEditor .internal{\n      position:absolute;\n      top:0;\n      left:0;\n      width:100%;\n      height:100%;\n      pointer-events:auto;\n    }\n\n.annotationEditorLayer .highlightEditor.disabled .internal{\n      pointer-events:none;\n    }\n\n.annotationEditorLayer .highlightEditor.selectedEditor .internal{\n        cursor:pointer;\n      }\n\n.annotationEditorLayer .highlightEditor .editToolbar{\n      --editor-toolbar-colorpicker-arrow-image:url(images/toolbarButton-menuArrow.svg);\n\n      transform-origin:center !important;\n    }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker{\n          position:relative;\n          width:auto;\n          display:flex;\n          justify-content:center;\n          align-items:center;\n          gap:4px;\n          padding:4px;\n        }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker::after{\n            content:\"\";\n            -webkit-mask-image:var(--editor-toolbar-colorpicker-arrow-image);\n                    mask-image:var(--editor-toolbar-colorpicker-arrow-image);\n            -webkit-mask-repeat:no-repeat;\n                    mask-repeat:no-repeat;\n            -webkit-mask-position:center;\n                    mask-position:center;\n            display:inline-block;\n            background-color:var(--editor-toolbar-fg-color);\n            width:12px;\n            height:12px;\n          }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker:hover::after{\n            background-color:var(--editor-toolbar-hover-fg-color);\n          }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker:has(.dropdown:not(.hidden)){\n            background-color:var(--editor-toolbar-hover-bg-color);\n          }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker:has(.dropdown:not(.hidden))::after{\n              scale:-1;\n            }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown{\n            position:absolute;\n            display:flex;\n            justify-content:center;\n            align-items:center;\n            flex-direction:column;\n            gap:11px;\n            padding-block:8px;\n            border-radius:6px;\n            background-color:var(--editor-toolbar-bg-color);\n            border:1px solid var(--editor-toolbar-border-color);\n            box-shadow:var(--editor-toolbar-shadow);\n            inset-block-start:calc(100% + 4px);\n            width:calc(100% + 2 * var(--editor-toolbar-padding));\n          }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button{\n              width:100%;\n              height:auto;\n              border:none;\n              cursor:pointer;\n              display:flex;\n              justify-content:center;\n              align-items:center;\n              background:none;\n            }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button:is(:active, :focus-visible){\n                outline:none;\n              }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button > .swatch{\n                outline-offset:2px;\n              }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button[aria-selected=\"true\"] > .swatch{\n                outline:2px solid var(--selected-outline-color);\n              }\n\n.annotationEditorLayer .highlightEditor .editToolbar .buttons .colorPicker .dropdown button:is(:hover, :active, :focus-visible) > .swatch{\n                outline:2px solid var(--hover-outline-color);\n              }\n\n.editorParamsToolbar:has(#highlightParamsToolbarContainer){\n  padding:unset;\n}\n\n#highlightParamsToolbarContainer{\n  height:auto;\n  padding-inline:10px;\n  padding-block:10px 16px;\n  gap:16px;\n  display:flex;\n  flex-direction:column;\n  box-sizing:border-box;\n}\n\n#highlightParamsToolbarContainer .editorParamsLabel{\n    width:-moz-fit-content;\n    width:fit-content;\n    inset-inline-start:0;\n  }\n\n#highlightParamsToolbarContainer .colorPicker{\n    display:flex;\n    flex-direction:column;\n    gap:8px;\n  }\n\n#highlightParamsToolbarContainer .colorPicker .dropdown{\n      display:flex;\n      justify-content:space-between;\n      align-items:center;\n      flex-direction:row;\n      height:auto;\n    }\n\n#highlightParamsToolbarContainer .colorPicker .dropdown button{\n        width:auto;\n        height:auto;\n        border:none;\n        cursor:pointer;\n        display:flex;\n        justify-content:center;\n        align-items:center;\n        background:none;\n        flex:0 0 auto;\n      }\n\n#highlightParamsToolbarContainer .colorPicker .dropdown button .swatch{\n          width:24px;\n          height:24px;\n        }\n\n#highlightParamsToolbarContainer .colorPicker .dropdown button:is(:active, :focus-visible){\n          outline:none;\n        }\n\n#highlightParamsToolbarContainer .colorPicker .dropdown button[aria-selected=\"true\"] > .swatch{\n          outline:2px solid var(--selected-outline-color);\n        }\n\n#highlightParamsToolbarContainer .colorPicker .dropdown button:is(:hover, :active, :focus-visible) > .swatch{\n          outline:2px solid var(--hover-outline-color);\n        }\n\n#highlightParamsToolbarContainer #editorHighlightThickness{\n    display:flex;\n    flex-direction:column;\n    align-items:center;\n    gap:4px;\n    align-self:stretch;\n  }\n\n#highlightParamsToolbarContainer #editorHighlightThickness .editorParamsLabel{\n      width:100%;\n      height:auto;\n      align-self:stretch;\n    }\n\n#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker{\n      display:flex;\n      justify-content:space-between;\n      align-items:center;\n      align-self:stretch;\n\n      --example-color:#bfbfc9;\n    }\n\n@media (prefers-color-scheme: dark){\n\n#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker{\n        --example-color:#80808e;\n    }\n      }\n\n@media screen and (forced-colors: active){\n\n#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker{\n        --example-color:CanvasText;\n    }\n      }\n\n:is(#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker > .editorParamsSlider[disabled]){\n        opacity:0.4;\n      }\n\n#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker::before,\n      #highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker::after{\n        content:\"\";\n        width:8px;\n        aspect-ratio:1;\n        display:block;\n        border-radius:100%;\n        background-color:var(--example-color);\n      }\n\n#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker::after{\n        width:24px;\n      }\n\n#highlightParamsToolbarContainer #editorHighlightThickness .thicknessPicker .editorParamsSlider{\n        width:unset;\n        height:14px;\n      }\n\n#highlightParamsToolbarContainer #editorHighlightVisibility{\n    display:flex;\n    flex-direction:column;\n    align-items:flex-start;\n    gap:8px;\n    align-self:stretch;\n  }\n\n#highlightParamsToolbarContainer #editorHighlightVisibility .divider{\n      --divider-color:#d7d7db;\n\n      margin-block:4px;\n      width:100%;\n      height:1px;\n      background-color:var(--divider-color);\n    }\n\n@media (prefers-color-scheme: dark){\n\n#highlightParamsToolbarContainer #editorHighlightVisibility .divider{\n        --divider-color:#8f8f9d;\n    }\n      }\n\n@media screen and (forced-colors: active){\n\n#highlightParamsToolbarContainer #editorHighlightVisibility .divider{\n        --divider-color:CanvasText;\n    }\n      }\n\n#highlightParamsToolbarContainer #editorHighlightVisibility .toggler{\n      display:flex;\n      justify-content:space-between;\n      align-items:center;\n      align-self:stretch;\n    }\n\n:root{\n  --viewer-container-height:0;\n  --pdfViewer-padding-bottom:0;\n  --page-margin:1px auto -8px;\n  --page-border:9px solid transparent;\n  --spreadHorizontalWrapped-margin-LR:-3.5px;\n  --loading-icon-delay:400ms;\n}\n\n@media screen and (forced-colors: active){\n  :root{\n    --pdfViewer-padding-bottom:9px;\n    --page-margin:8px auto -1px;\n    --page-border:1px solid CanvasText;\n    --spreadHorizontalWrapped-margin-LR:3.5px;\n  }\n}\n\n[data-main-rotation=\"90\"]{\n  transform:rotate(90deg) translateY(-100%);\n}\n[data-main-rotation=\"180\"]{\n  transform:rotate(180deg) translate(-100%, -100%);\n}\n[data-main-rotation=\"270\"]{\n  transform:rotate(270deg) translateX(-100%);\n}\n\n#hiddenCopyElement,\n.hiddenCanvasElement{\n  position:absolute;\n  top:0;\n  left:0;\n  width:0;\n  height:0;\n  display:none;\n}\n\n.pdfViewer{\n  --scale-factor:1;\n\n  padding-bottom:var(--pdfViewer-padding-bottom);\n\n  --hcm-highlight-filter:none;\n  --hcm-highlight-selected-filter:none;\n}\n\n@media screen and (forced-colors: active){\n\n.pdfViewer{\n    --hcm-highlight-filter:invert(100%);\n}\n  }\n\n.pdfViewer .canvasWrapper{\n    overflow:hidden;\n    width:100%;\n    height:100%;\n  }\n\n.pdfViewer .canvasWrapper canvas{\n      margin:0;\n      display:block;\n    }\n\n.pdfViewer .canvasWrapper canvas[hidden]{\n        display:none;\n      }\n\n.pdfViewer .canvasWrapper canvas[zooming]{\n        width:100%;\n        height:100%;\n      }\n\n.pdfViewer .canvasWrapper canvas .structTree{\n        contain:strict;\n      }\n\n.pdfViewer .page{\n  direction:ltr;\n  width:816px;\n  height:1056px;\n  margin:var(--page-margin);\n  position:relative;\n  overflow:visible;\n  border:var(--page-border);\n  background-clip:content-box;\n  background-color:rgb(255 255 255);\n}\n\n.pdfViewer .dummyPage{\n  position:relative;\n  width:0;\n  height:var(--viewer-container-height);\n}\n\n.pdfViewer.noUserSelect{\n  -webkit-user-select:none;\n     -moz-user-select:none;\n          user-select:none;\n}\n\n.pdfViewer.removePageBorders .page{\n  margin:0 auto 10px;\n  border:none;\n}\n\n.pdfViewer.singlePageView{\n  display:inline-block;\n}\n\n.pdfViewer.singlePageView .page{\n  margin:0;\n  border:none;\n}\n\n.pdfViewer:is(.scrollHorizontal, .scrollWrapped),\n.spread{\n  margin-inline:3.5px;\n  text-align:center;\n}\n\n.pdfViewer.scrollHorizontal,\n.spread{\n  white-space:nowrap;\n}\n\n.pdfViewer.removePageBorders,\n.pdfViewer:is(.scrollHorizontal, .scrollWrapped) .spread{\n  margin-inline:0;\n}\n\n.spread :is(.page, .dummyPage),\n.pdfViewer:is(.scrollHorizontal, .scrollWrapped) :is(.page, .spread){\n  display:inline-block;\n  vertical-align:middle;\n}\n\n.spread .page,\n.pdfViewer:is(.scrollHorizontal, .scrollWrapped) .page{\n  margin-inline:var(--spreadHorizontalWrapped-margin-LR);\n}\n\n.pdfViewer.removePageBorders .spread .page,\n.pdfViewer.removePageBorders:is(.scrollHorizontal, .scrollWrapped) .page{\n  margin-inline:5px;\n}\n\n.pdfViewer .page.loadingIcon::after{\n  position:absolute;\n  top:0;\n  left:0;\n  content:\"\";\n  width:100%;\n  height:100%;\n  background:url(\"images/loading-icon.gif\") center no-repeat;\n  display:none;\n  transition-property:display;\n  transition-delay:var(--loading-icon-delay);\n  z-index:5;\n  contain:strict;\n}\n\n.pdfViewer .page.loading::after{\n  display:block;\n}\n\n.pdfViewer .page:not(.loading)::after{\n  transition-property:none;\n  display:none;\n}\n\n.pdfPresentationMode .pdfViewer{\n  padding-bottom:0;\n}\n\n.pdfPresentationMode .spread{\n  margin:0;\n}\n\n.pdfPresentationMode .pdfViewer .page{\n  margin:0 auto;\n  border:2px solid transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
